  (function(){
  
    function initITFFAQ(root){
  
      if (!root) return;
  
      // Prevent duplicate initialization
      if (root.dataset.initialized === 'true') return;
  
      root.dataset.initialized = 'true';
  
      const navContainer = root.querySelector('.faq-nav');
      const contentContainer = root.querySelector('.faq-content');
  
      const modal = root.querySelector('.itf-info-modal');
      const modalContent = root.querySelector('.itf-info-modal-content');
      const modalClose = root.querySelector('.itf-info-modal-close');
  
      /* FAQ DATA */
  
      const faqData = {
  
        "Account & Profile": [
  
    {
      sub: "Account Creation & Login",
  
      questions: [
  
        {
          q: "How do I create a new account on IT Factory Australia?",
  
          a: `
            <p>
              You can create an account by clicking the account icon in the top right of the website.
            </p>
            <p>
              From there, you can sign up using your Shop account or enter your email address and follow the confirmation steps sent to your inbox.
            </p>
            <p>
              You can also choose to tick the box to receive exclusive deals and offers if you would like to join the ITF Insider Club.
            </p>
          `
        },
  
        {
          q: "Can I create an account using my social media account?",
  
          a: `
            <p>
              You can sign in using Shop if you prefer a faster account login experience.
            </p>
            <p>
              Other social login options are not currently available through IT Factory Australia.
            </p>
          `
        },
  
        {
          q: "Do I need an account to make a purchase?",
  
          a: `
            <p>
              No, you do not need an account to make a purchase.
            </p>
            <p>
              You can check out as a guest, but creating an account can make it easier to view your orders, manage addresses, and track purchases later.
            </p>
          `
        },
  
        {
          q: "How do I log in to my account?",
  
          a: `
            <p>
              You can log in by clicking the account icon in the top right of the website.
            </p>
            <p>
              You can then sign in using Shop or enter your email address to receive a secure login code.
            </p>
          `
        },
  
        {
          q: "What should I do if I forget my password?",
  
          a: `
            <p>
              You do not need a password to sign in to your IT Factory Australia account.
            </p>
            <p>
              Enter your email address on the login page and a secure login code will be sent to your inbox.
            </p>
          `
        },
  
        {
          q: "Can I change my password after logging in?",
  
          a: `
            <p>
              IT Factory Australia accounts do not require a password.
            </p>
            <p>
              You can sign in using Shop or by entering the secure login code sent to your email address.
            </p>
          `
        },
  
        {
          q: "How do I update my security questions or account recovery options?",
  
          a: `
            <p>
              IT Factory Australia does not use security questions for customer accounts.
            </p>
            <p>
              Your account access is handled through Shop or a secure login code sent to your email address.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Account Management",
  
      questions: [
  
        {
          q: "How do I update my personal details (name, email, phone number)?",
  
          a: `
            <p>
              You can update your account details by signing in to your account and selecting <strong>Profile</strong>.
            </p>
            <p>
              From there, you can edit your email address, manage your default address, and add saved addresses.
            </p>
          `
        },
  
        {
          q: "How do I add, edit, or remove my shipping addresses?",
  
          a: `
            <p>
              Sign in to your account, select <strong>Profile</strong>, then manage your saved addresses.
            </p>
            <p>
              You can edit your default address and add new addresses from your profile area.
            </p>
          `
        },
  
        {
          q: "Can I change my email address associated with my account?",
  
          a: `
            <p>
              Yes, you can change the email address linked to your account yourself.
            </p>
            <p>
              Sign in to your account, go to <strong>Profile</strong>, then use the edit option to update your email address.
            </p>
          `
        },
  
        {
          q: "How do I manage my communication preferences and newsletter subscriptions?",
  
          a: `
            <p>
              You can manage email preferences from your account by going to <strong>Profile</strong>, selecting the edit icon near your email, and unticking <strong>Sign up to get exclusive deals and offers</strong>.
            </p>
            <p>
              You can also unsubscribe from marketing emails by selecting the <strong>Unsubscribe</strong> link at the bottom of any marketing email you receive from us.
            </p>
          `
        },
  
        {
          q: "Can I view my order history in my account?",
  
          a: `
            <p>
              Yes, you can view your order history from your account.
            </p>
            <p>
              Sign in to your account and select <strong>Orders</strong> to see your previous purchases.
            </p>
          `
        },
  
        {
          q: "How do I track the status of my orders from my account?",
  
          a: `
            <p>
              Sign in to your account, select <strong>Orders</strong>, then choose the order you want to check.
            </p>
            <p>
              If you checked out as a guest, you can use the tracking email sent to you after your order has been dispatched.
            </p>
          `
        },
  
        {
          q: "How can I save items to a wishlist or favourites list?",
  
          a: `
            <p>
              Wishlist and favourites features are not currently available on IT Factory Australia.
            </p>
            <p>
              If an unavailable product has a notification option, you can choose to be notified when that item is back in stock.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Account Security",
  
      questions: [
  
        {
          q: "How do I enable two-factor authentication (2FA)?",
  
          a: `
            <p>
              Customer two-factor authentication is not currently available as a separate account setting.
            </p>
            <p>
              Your account is protected by secure email login codes or Shop login, so access depends on the email address connected to your account.
            </p>
          `
        },
  
        {
          q: "How can I tell if my account has been compromised?",
  
          a: `
            <p>
              A possible warning sign is receiving a login code email when you were not trying to sign in.
            </p>
            <p>
              If this happens, do not share the code with anyone. You should also check that your email account is secure.
            </p>
          `
        },
  
        {
          q: "What should I do if I suspect someone else is using my account?",
  
          a: `
            <p>
              Contact IT Factory Australia support as soon as possible so we can help review the issue.
            </p>
            <p>
              You should also secure the email address linked to your account, especially if you think someone else may have access to your inbox.
            </p>
            <p>
              Email us at <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a> or call <a href="tel:1300589579">1300 589 579</a> and select option 1.
            </p>
          `
        },
  
        {
          q: "How do I securely log out from shared devices?",
  
          a: `
            <p>
              Sign in to your account, go to <strong>Profile</strong>, then choose <strong>Sign out</strong> or <strong>Sign out of all devices</strong>.
            </p>
            <p>
              If you are using a shared device, you should also close the browser when finished.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Account Closure & Restrictions",
  
      questions: [
  
        {
          q: "How do I deactivate or close my account?",
  
          a: `
            <p>
              You can contact IT Factory Australia support and ask us to delete your account for you.
            </p>
            <p>
              Email <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a> or call <a href="tel:1300589579">1300 589 579</a> and select option 1.
            </p>
          `
        },
  
        {
          q: "Can I reactivate a closed account?",
  
          a: `
            <p>
              No, closed accounts cannot currently be reactivated.
            </p>
            <p>
              If you want to shop with us again, you will need to create a new account using your email address.
            </p>
          `
        },
  
        {
          q: "Are there any restrictions on account usage for purchasing refurbished products?",
  
          a: `
            <p>
              You should use accurate details when creating an account or placing an order.
            </p>
            <p>
              If an order is flagged for possible fraud or payment risk, we may ask you to provide another payment method, identification, or additional information before the order can proceed.
            </p>
          `
        },
  
        {
          q: "Can I have multiple accounts with IT Factory Australia?",
  
          a: `
            <p>
              You can create multiple accounts using different email addresses, but we do not recommend it.
            </p>
            <p>
              Using one account makes it easier to keep your order history, saved addresses, and account details in one place.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Business Accounts",
  
      questions: [
  
        {
          q: "Can businesses create a separate account?",
  
          a: `
            <p>
              Yes, you can create a business account if you would like to.
            </p>
            <p>
              You can also use a regular account and add business shipping or billing details when placing an order.
            </p>
            <p>
              If you want your company added to our database for options like custom pricing or net payment terms, please contact us.
            </p>
          `
        },
  
        {
          q: "Are there benefits for business accounts compared to personal accounts?",
  
          a: `
            <p>
              Business accounts may be eligible for options such as custom pricing, net payment terms, custom quotes, and bulk order support.
            </p>
            <p>
              Bulk orders should always be requested through our contact page or by emailing our support team so we can review your needs properly.
            </p>
          `
        },
  
        {
          q: "How do I request a business account or bulk ordering privileges?",
  
          a: `
            <p>
              You can contact us through the contact page or email our support team directly.
            </p>
            <p>
              To help us prepare the right response, please include your business name, ABN if available, contact person, products needed, quantity, and budget.
            </p>
            <p>
              Email <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a> or call <a href="tel:1300589579">1300 589 579</a> and select option 1.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Technical Issues",
  
      questions: [
  
        {
          q: "Why am I unable to log in even with the correct credentials?",
  
          a: `
            <p>
              First, check that your email address is entered correctly and that the login code matches the latest code sent to your inbox.
            </p>
            <p>
              If it still does not work, try clearing your browser cache, using another browser, or checking that an account exists for that email address.
            </p>
            <p>
              If you still need help, contact us at <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a>.
            </p>
          `
        },
  
        {
          q: "Why is my account temporarily locked?",
  
          a: `
            <p>
              If you cannot access your account, it may be related to a login, browser, email, or account verification issue.
            </p>
            <p>
              Try requesting a new login code and checking that you are using the correct email address. If the issue continues, contact our support team for help.
            </p>
          `
        },
  
        {
          q: "How do I fix account-related errors on mobile or desktop?",
  
          a: `
            <p>
              Try refreshing the page, clearing your browser cache, updating your browser, opening the site in a private window, or using another device.
            </p>
            <p>
              If the issue continues, contact IT Factory Australia support with details of the error and the device or browser you are using.
            </p>
          `
        }
  
      ]
    }
  
  ],
  
        "Orders & Tracking": [
  
    {
      sub: "Placing Orders",
  
      questions: [
  
        {
          q: "How do I place an order on IT Factory Australia?",
  
          a: `
            <p>
              You can place an order directly through our website by browsing the product you want, selecting the available quantity, and adding it to your cart.
            </p>
            <p>
              From there, go to checkout, enter your shipping and payment details, add any discount code if applicable, then place your order.
            </p>
            <p>
              Once your order is placed, you will receive an order confirmation. Tracking details will be sent after your order has been dispatched.
            </p>
          `
        },
  
        {
          q: "Can I place an order without creating an account?",
  
          a: `
            <p>
              Yes, you can place an order without creating an account.
            </p>
            <p>
              You can check out as a guest, but creating an account can make it easier to view your order history and track orders later.
            </p>
          `
        },
  
        {
          q: "Can I order multiple items in a single purchase?",
  
          a: `
            <p>
              Yes, you can order multiple items in a single purchase.
            </p>
            <p>
              Any available product and available quantity shown on the website can be added to your cart and purchased through checkout.
            </p>
          `
        },
  
        {
          q: "Is there a minimum or maximum order quantity?",
  
          a: `
            <p>
              There is no standard minimum or maximum order quantity for regular online orders.
            </p>
            <p>
              If you need to place a bulk order, please contact us first through our contact page or support email so we can review availability and prepare the right solution.
            </p>
          `
        },
  
        {
          q: "Can I order refurbished products in bulk?",
  
          a: `
            <p>
              Yes, you can request refurbished products in bulk.
            </p>
            <p>
              Bulk orders are handled through our support team first so we can check product availability, quantities, pricing, and any specific requirements before confirming the order.
            </p>
            <p>
              Email us at <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a> or use our <a href="https://itfactoryaustralia.com.au/pages/contact">contact page</a>.
            </p>
          `
        },
  
        {
          q: "Can I schedule an order for a future date?",
  
          a: `
            <p>
              Future-dated orders are not currently available through our online checkout.
            </p>
            <p>
              If you have a special business or bulk order request, you can contact us and we will let you know what options may be available.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Order Confirmation",
  
      questions: [
  
        {
          q: "How do I know if my order was successfully placed?",
  
          a: `
            <p>
              Your order has been successfully placed when you see the thank-you page after checkout and receive your order confirmation email.
            </p>
            <p>
              Your confirmation will include your order number, and if you have an account, you can also view the order in your account order history.
            </p>
          `
        },
  
        {
          q: "Why haven’t I received my order confirmation email?",
  
          a: `
            <p>
              First, check your junk or spam folder in case the confirmation email was filtered there.
            </p>
            <p>
              It may also be delayed if there was an email typo, payment issue, or order review needed. If there are any issues or delays on our end, we will contact you.
            </p>
            <p>
              If you still cannot find it, email us at <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a>.
            </p>
          `
        },
  
        {
          q: "What details are included in the order confirmation?",
  
          a: `
            <p>
              Your order confirmation usually includes your order number, purchased items, pricing and payment details, shipping details, billing details, payment method, and a <strong>View your order</strong> link.
            </p>
          `
        },
  
        {
          q: "Can I change the email address for my order confirmation?",
  
          a: `
            <p>
              You can contact us to update the email address connected to your order after purchase.
            </p>
            <p>
              Please note that the new email address will only receive future emails. Previous emails, such as the original order confirmation, will not automatically be resent unless requested.
            </p>
            <p>
              Shipping details may also be changed before dispatch, but billing details cannot be changed after purchase.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Modifying Orders",
  
      questions: [
  
        {
          q: "Can I change the items in my order after placing it?",
  
          a: `
            <p>
              You can request changes to the items or quantities in your order before it has been dispatched.
            </p>
            <p>
              Please contact us as soon as possible at <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a> so we can check whether the order can still be updated before dispatch.
            </p>
          `
        },
  
        {
          q: "How do I update my shipping address after placing an order?",
  
          a: `
            <p>
              You can request a shipping address change before your order has been dispatched.
            </p>
            <p>
              Please email <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a> as soon as possible with your order number and the correct shipping address.
            </p>
            <p>
              Billing addresses cannot be changed after purchase.
            </p>
          `
        },
  
        {
          q: "Can I add items to an existing order?",
  
          a: `
            <p>
              You may be able to add items to an existing order before it has been dispatched.
            </p>
            <p>
              If your order has already been dispatched, you will need to place a new order for any additional items.
            </p>
          `
        },
  
        {
          q: "Can I cancel an order after it has been placed?",
  
          a: `
            <p>
              You can request an order cancellation before your order has been dispatched.
            </p>
            <p>
              Please email <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a> as soon as possible with your order number so we can check whether cancellation is still possible.
            </p>
          `
        },
  
        {
          q: "Are there any restrictions for cancelling or modifying orders?",
  
          a: `
            <p>
              Yes. Once an order has already been shipped, we cannot cancel or modify it.
            </p>
            <p>
              For time-sensitive changes, please contact us as soon as possible before dispatch.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Payment & Invoicing",
  
      questions: [
  
        {
          q: "How can I view or download my invoice?",
  
          a: `
            <p>
              You can download your invoice from your order page.
            </p>
            <p>
              If you need help finding it or need a copy resent, contact us at <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a>.
            </p>
          `
        },
  
        {
          q: "What payment methods are accepted when placing an order?",
  
          a: `
            <p>
              We currently accept Afterpay, American Express, Apple Pay, Google Pay, Mastercard, Shop Pay, and Visa.
            </p>
          `
        },
  
        {
          q: "Can I split payment between multiple methods?",
  
          a: `
            <p>
              Split payments between multiple payment methods are not currently available through our online checkout.
            </p>
          `
        },
  
        {
          q: "How do I know if my payment was successful?",
  
          a: `
            <p>
              Your payment is successful when your order is completed at checkout and you receive your order confirmation.
            </p>
            <p>
              Your confirmation email will include your order details and payment information.
            </p>
          `
        },
  
        {
          q: "What should I do if my payment fails?",
  
          a: `
            <p>
              First, check that your payment details are correct and try another card or payment method if available.
            </p>
            <p>
              If the issue continues, you may need to contact your bank or payment provider.
            </p>
            <p>
              You can also email us at <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a> if you need help checking the order status.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Order Tracking",
  
      questions: [
  
        {
          q: "How can I track my order after it has been placed?",
  
          a: `
            <p>
              Once your order has been dispatched, you will receive an email with your tracking details.
            </p>
            <p>
              You can also track your order using the order page link in your confirmation email or tracking email.
            </p>
          `
        },
  
        {
          q: "Can I track orders that are shipped internationally?",
  
          a: `
            <p>
              IT Factory Australia does not currently offer standard international ordering through the website.
            </p>
            <p>
              International orders may only be considered case-by-case after you contact us first. If an international order is approved, tracking details will depend on the courier and shipment method used.
            </p>
          `
        },
  
        {
          q: "Why is my tracking information not updating?",
  
          a: `
            <p>
              Tracking updates can take time to appear after dispatch, especially while the courier is processing or scanning the shipment.
            </p>
            <p>
              Please allow up to 24 hours after dispatch or courier scan for tracking information to update.
            </p>
          `
        },
  
        {
          q: "What do I do if my tracking number doesn’t work?",
  
          a: `
            <p>
              Please allow up to 24 hours after dispatch or courier scan, then check the courier tracking link again.
            </p>
            <p>
              If the tracking number still does not work after that time, email us at <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a>.
            </p>
          `
        },
  
        {
          q: "How long does it take for tracking information to appear?",
  
          a: `
            <p>
              Tracking details are usually sent once your order has been dispatched.
            </p>
            <p>
              In some cases, courier tracking may appear immediately or take a few hours to update. Please allow up to 24 hours after dispatch or courier scan for tracking to fully appear.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Order Issues",
  
      questions: [
  
        {
          q: "What should I do if I receive the wrong item?",
  
          a: `
            <p>
              Please contact us as soon as possible so we can review the issue and provide the next steps.
            </p>
            <p>
              Include your order number, photos of the item received, photos of the packaging, and the package dimensions where possible.
            </p>
            <p>
              Once reviewed, we can provide a return label if the item needs to be sent back to us.
            </p>
          `
        },
  
        {
          q: "What should I do if my order is missing an item?",
  
          a: `
            <p>
              First, check the packaging carefully and compare the items received with your order confirmation.
            </p>
            <p>
              If something is still missing, contact us with your order number and details of the missing item.
            </p>
            <p>
              You can email <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a> or call <a href="tel:1300589579">1300 589 579</a> and select option 1.
            </p>
          `
        },
  
        {
          q: "What happens if my order is damaged during shipping?",
  
          a: `
            <p>
              Please take clear photos of the damaged item and packaging, keep the packaging where possible, and contact us as soon as you notice the issue.
            </p>
            <p>
              Shipping damage is assessed based on the circumstances of the order and is not limited solely by our voluntary hardware warranty period.
            </p>
            <p>
              Email <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a> with your order number and damage details so we can review the appropriate next steps.
            </p>
          `
        },
  
        {
          q: "Who should I contact if there is an issue with my order?",
  
          a: `
            <p>
              The best way to contact us about an order issue is by emailing <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a>.
            </p>
            <p>
              You can also call <a href="tel:1300589579">1300 589 579</a> and select option 1.
            </p>
          `
        },
  
        {
          q: "Can I request a replacement for a defective product?",
  
          a: `
            <p>
              Yes, you can contact us to request help with a defective product.
            </p>
            <p>
              We will review the issue and let you know the next steps. Replacement options may depend on the fault, warranty eligibility, and available stock.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Special Orders & Business Orders",
  
      questions: [
  
        {
          q: "Can I request a specific configuration for a refurbished device?",
  
          a: `
            <p>
              Yes, you can request a specific model or configuration, but availability depends on our current stock and what can be sourced or prepared.
            </p>
            <p>
              Please email us first with the details you need, such as the device type, model, RAM, storage, quantity, and budget.
            </p>
          `
        },
  
        {
          q: "How do business accounts place bulk or corporate orders?",
  
          a: `
            <p>
              Business and corporate orders should be requested through our support team first.
            </p>
            <p>
              Please include your business name, ABN if available, contact person, products needed, quantity, budget, and any timing requirements.
            </p>
            <p>
              Email <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a> or use our <a href="https://itfactoryaustralia.com.au/pages/contact">contact page</a>.
            </p>
          `
        },
  
        {
          q: "Are there discounts for bulk orders?",
  
          a: `
            <p>
              Bulk pricing may be reviewed case-by-case depending on the products, quantity, availability, and order requirements.
            </p>
            <p>
              Please email <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a> with your order details so we can assess what may be available.
            </p>
          `
        },
  
        {
          q: "Can I request priority processing for large orders?",
  
          a: `
            <p>
              Priority processing applies automatically for ITF Insiders.
            </p>
            <p>
              If you need an order urgently, please email us at <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a> as soon as possible so we can review what may be possible.
            </p>
          `
        }
  
      ]
    }
  
  ],
  
        "Shipping & Delivery": [
  
    {
      sub: "Shipping Options",
  
      questions: [
  
        {
          q: "What shipping methods are available at IT Factory Australia?",
  
          a: `
            <p>
              Free standard shipping is included on all online orders delivered within Australia.
            </p>
            <p>
              Express shipping can also be specially requested by contacting us before dispatch. Express requests are assessed individually based on the order, delivery location, courier availability and required timeframe, and an additional charge may apply.
            </p>
            <p>
              Pickup by appointment is available from our Wetherill Park location after a suitable collection day and time has been confirmed.
            </p>
            <p>
              We mainly use Australia Post, CouriersPlease and Aramex Australia for standard deliveries, depending on the order and destination.
            </p>
          `
        },
  
        {
          q: "Do you offer express or same-day shipping?",
  
          a: `
            <p>
              Express shipping is not currently offered as a standard checkout option, but you can request it by contacting us before dispatch.
            </p>
            <p>
              We assess express requests individually based on your delivery location, the product, courier availability, the required timeframe and the status of your order.
            </p>
            <p>
              An additional shipping charge may apply. If it does, we will confirm the cost with you before proceeding.
            </p>
            <p>
              Same-day delivery is not a standard service and cannot be guaranteed. If you have an urgent requirement, contact us and we can check what may be possible.
            </p>
            <p>
              Email <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a> or call <a href="tel:1300589579">1300 589 579</a> and select option 1.
            </p>
          `
        },
  
        {
          q: "Can I choose a specific courier for my order?",
  
          a: `
            <p>
              IT Factory Australia selects the most suitable courier for your order based on the product, delivery location, and available shipping options.
            </p>
            <p>
              If you prefer a specific courier, you can contact us before dispatch and we will do our best to accommodate your request where possible.
            </p>
          `
        },
  
        {
          q: "Do you provide in-store pickup or click-and-collect options?",
  
          a: `
            <p>
              Yes, pickup is available by appointment only from our Wetherill Park warehouse.
            </p>
            <p>
              To arrange pickup, contact us by email or phone so we can confirm a suitable collection day and time.
            </p>
            <p>
              Email <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a> or call <a href="tel:1300589579">1300 589 579</a> and select option 1.
            </p>
          `
        },
  
        {
          q: "Are there restrictions on shipping refurbished devices?",
  
          a: `
            <p>
              There are no major standard shipping restrictions for refurbished devices sold through IT Factory Australia.
            </p>
            <p>
              If there is ever a delivery issue with your address, courier availability, or order type, we will contact you before dispatch.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Shipping Costs",
  
      questions: [
  
        {
          q: "How much does shipping cost?",
  
          a: `
            <p>
              Standard shipping is free on all online orders delivered within Australia. There is no minimum spend required.
            </p>
            <p>
              This includes metropolitan, regional and remote Australian locations.
            </p>
            <p>
              Express shipping is available by request where possible and may involve an additional charge. Any additional cost will be confirmed with you before the express arrangement proceeds.
            </p>
            <p>
              International shipping, where approved case-by-case, has separate shipping costs.
            </p>
            <p>
              For full details, review our <a href="https://itfactoryaustralia.com.au/policies/shipping-policy">Shipping Policy</a>.
            </p>
          `
        },
  
        {
          q: "Is shipping free for certain orders or promotions?",
  
          a: `
            <p>
              Free standard shipping is included on all IT Factory Australia online orders delivered within Australia.
            </p>
            <p>
              There is no minimum spend and you do not need a promotion or discount code to receive free standard shipping.
            </p>
            <p>
              Optional express shipping requests and approved international orders are handled separately and may have additional shipping costs.
            </p>
          `
        },
  
        {
          q: "Do shipping costs vary for regional or remote locations?",
  
          a: `
            <p>
              No, standard shipping is free Australia-wide, including regional and remote locations.
            </p>
            <p>
              Delivery timeframes may vary depending on your location and courier network conditions.
            </p>
          `
        },
  
        {
          q: "Are there additional fees for bulky or heavy items?",
  
          a: `
            <p>
              No, there are no standard extra shipping fees for bulky or heavy items delivered within Australia.
            </p>
            <p>
              If any unusual shipping requirement applies, we will contact you before dispatch.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Delivery Time",
  
      questions: [
  
        {
          q: "How long does standard shipping take?",
  
          a: `
            <p>
              Orders are usually dispatched within 2 business days after your order details and final quality check are completed.
            </p>
            <p>
              Delivery times are estimates and can vary by location, courier network conditions, public holidays, sale periods, and weather events.
            </p>
            <p>
              <span
                class="info-popup"
                data-info='
                  <h3>Estimated Delivery Timeframes</h3>
                  <p>These are general delivery estimates after dispatch and may vary depending on courier conditions.</p>
                  <ul>
                    <li>Brisbane, Sydney, ACT, and Melbourne: usually around 2 to 3 business days</li>
                    <li>Adelaide, Darwin, and Hobart: usually around 3 to 5 business days</li>
                    <li>Perth: usually around 7 to 10 business days</li>
                    <li>Regional and remote areas may take longer depending on courier access and network conditions</li>
                  </ul>
                '
              >
                View estimated delivery timeframes
              </span>
            </p>
          `
        },
  
        {
          q: "How long does express shipping take?",
  
          a: `
            <p>
              Express shipping does not have one standard delivery timeframe because it is arranged by request rather than offered as a standard checkout service.
            </p>
            <p>
              If you need express delivery, contact us before dispatch and tell us your delivery postcode and required timeframe.
            </p>
            <p>
              We will check the available courier options and advise you of the expected delivery timeframe and any additional shipping cost before proceeding.
            </p>
          `
        },
  
        {
          q: "Why is my order taking longer than expected to arrive?",
  
          a: `
            <p>
              Delivery can sometimes take longer due to courier delays, remote delivery locations, public holidays, high-order periods, weather, incorrect address details, or courier scanning delays.
            </p>
            <p>
              Once your order has been dispatched, courier delays are outside our direct control, but we can still help you check the shipment if you are concerned.
            </p>
          `
        },
  
        {
          q: "How can I estimate delivery time for my location?",
  
          a: `
            <p>
              You can use the tracking link in your tracking email once your order has been dispatched.
            </p>
            <p>
              If you want help estimating delivery time before or after placing an order, contact us with your postcode and we can provide general guidance.
            </p>
          `
        },
  
        {
          q: "Do delivery times differ for business or bulk orders?",
  
          a: `
            <p>
              Business and bulk orders do not always take longer, but timing can depend on the products, quantity, testing, packing, and order requirements.
            </p>
            <p>
              If timing is important, please contact us before placing or finalising your order.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "International Shipping",
  
      questions: [
  
        {
          q: "Do you ship orders outside Australia?",
  
          a: `
            <p>
              International shipping is not currently available as a standard checkout option.
            </p>
            <p>
              International orders may only be considered case-by-case after you contact us first and receive approval.
            </p>
          `
        },
  
        {
          q: "Are there any restrictions on international shipments?",
  
          a: `
            <p>
              Yes, international shipments may depend on the destination, courier availability, product type, and warranty or return complexity.
            </p>
            <p>
              Please contact us before ordering so we can review whether international shipping may be possible for your request.
            </p>
          `
        },
  
        {
          q: "Who is responsible for customs duties or taxes on international orders?",
  
          a: `
            <p>
              If an international order is approved, extra shipping fees will apply.
            </p>
            <p>
              You are also responsible for any customs duties, taxes, import fees, or related charges that may apply in your country.
            </p>
          `
        },
  
        {
          q: "How can I track my international shipment?",
  
          a: `
            <p>
              If an international order is approved and dispatched, tracking details will be sent to you by email.
            </p>
            <p>
              The available tracking information will depend on the courier and shipment method used.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Tracking Orders",
  
      questions: [
  
        {
          q: "How do I track my shipment?",
  
          a: `
            <p>
              Once your order has been dispatched, you will receive an email with your tracking details.
            </p>
            <p>
              If you have an account, you can also access tracking from the order page link in your account.
            </p>
          `
        },
  
        {
          q: "Why hasn’t my tracking number updated?",
  
          a: `
            <p>
              Tracking can take time to appear after dispatch, especially while the courier is processing or scanning the parcel.
            </p>
            <p>
              Please allow up to 24 hours after dispatch or courier scan for tracking to update.
            </p>
          `
        },
  
        {
          q: "What should I do if my shipment tracking shows an error?",
  
          a: `
            <p>
              If your tracking shows an error or does not look right, contact us and we can help review it.
            </p>
            <p>
              Email <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a> with your order number and tracking details.
            </p>
          `
        },
  
        {
          q: "Can I change the delivery address after the order has been shipped?",
  
          a: `
            <p>
              No, the delivery address cannot be changed once your order has already been shipped.
            </p>
            <p>
              If you need to change your address, please contact us as soon as possible before dispatch.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Delivery Issues",
  
      questions: [
  
        {
          q: "What should I do if my package is lost or delayed?",
  
          a: `
            <p>
              First, check your tracking link for the latest courier update and allow the expected delivery timeframe for your location.
            </p>
            <p>
              If your package appears delayed or lost, you can contact the courier first, then contact IT Factory Australia support if you need further help.
            </p>
            <p>
              Email <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a> with your order number and tracking details.
            </p>
          `
        },
  
        {
          q: "Who do I contact if my package is damaged during shipping?",
  
          a: `
            <p>
              Please contact IT Factory Australia support directly if your package arrives damaged.
            </p>
            <p>
              Include your order number, clear photos of the damage, and photos of the packaging so we can review the issue and advise the next steps.
            </p>
            <p>
              Email <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a> or call <a href="tel:1300589579">1300 589 579</a> and select option 1.
            </p>
          `
        },
  
        {
          q: "What happens if I’m not home when my delivery arrives?",
  
          a: `
            <p>
              In most cases, the courier will take your package to the closest depot or pickup location.
            </p>
            <p>
              Please follow the instructions from the courier. If you have trouble arranging collection or redelivery, contact IT Factory Australia support.
            </p>
          `
        },
  
        {
          q: "Can I request a redelivery if I missed the courier?",
  
          a: `
            <p>
              Yes, if you missed the courier, contact IT Factory Australia support as soon as possible so we can help organise a redelivery where available.
            </p>
            <p>
              Redelivery options may depend on the courier and shipment status.
            </p>
          `
        },
  
        {
          q: "How do I report missing items from a delivered order?",
  
          a: `
            <p>
              First, check the packaging carefully and compare the delivered items with your order confirmation.
            </p>
            <p>
              If something is still missing, contact us with your order number, details of the missing item, and photos if needed.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "In-Store Pickup",
  
      questions: [
  
        {
          q: "How do I arrange a pickup appointment at the Wetherill Park store?",
  
          a: `
            <p>
              Pickup is available by appointment only from our Wetherill Park warehouse.
            </p>
            <p>
              Contact us through our contact page, support email, or phone number, then wait for us to confirm a suitable collection day and time.
            </p>
            <p>
              <span
                class="info-popup"
                data-info='
                  <h3>Pickup Appointment Steps</h3>
                  <ol>
                    <li>Contact us by email, phone, or the contact page.</li>
                    <li>Provide your order number and preferred pickup timing.</li>
                    <li>Wait for confirmation before visiting the warehouse.</li>
                    <li>Bring your order confirmation email and photo ID when collecting.</li>
                  </ol>
                  <p>Please do not visit without a confirmed appointment time.</p>
                '
              >
                View pickup appointment steps
              </span>
            </p>
          `
        },
  
        {
          q: "Are there any fees for in-store pickup?",
  
          a: `
            <p>
              No, pickup from our Wetherill Park warehouse is free.
            </p>
            <p>
              Pickup must still be arranged by appointment before you visit.
            </p>
          `
        },
  
        {
          q: "How long will my order be held for pickup?",
  
          a: `
            <p>
              Your pickup order will be held for the confirmed appointment day and time.
            </p>
            <p>
              If you cannot collect it at the arranged time, contact us as soon as possible so we can organise another suitable day and time.
            </p>
          `
        },
  
        {
          q: "What identification or documentation do I need for pickup?",
  
          a: `
            <p>
              Please bring your order confirmation email and photo ID when collecting your order.
            </p>
            <p>
              This helps us confirm the correct order is being collected by the right person.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Special Instructions",
  
      questions: [
  
        {
          q: "Can I add special delivery instructions for my order?",
  
          a: `
            <p>
              Yes, you can add special delivery notes from your cart before you go to checkout.
            </p>
            <p>
              Please add any important delivery instructions on the cart page before completing your order.
            </p>
          `
        },
  
        {
          q: "Can I request discreet packaging for my device?",
  
          a: `
            <p>
              All IT Factory Australia orders are packed in discreet packaging.
            </p>
            <p>
              Your order is packed securely and prepared for safe delivery without unnecessary attention to the contents.
            </p>
          `
        },
  
        {
          q: "How do I request delivery on a specific date or time?",
  
          a: `
            <p>
              You can add delivery notes from your cart before checkout, but specific delivery dates or times cannot be guaranteed.
            </p>
            <p>
              Courier delivery timing depends on the courier, route, location, and shipment status.
            </p>
          `
        }
  
      ]
    }
  
  ],
  
  "Warranty & Returns": [
  
    {
      sub: "Warranty Coverage",
  
      questions: [
  
        {
          q: "What warranty comes with refurbished devices?",
  
          a: `
            <p>
              Standard eligible refurbished products include our voluntary 6-month hardware warranty for eligible hardware-related faults, subject to assessment.
            </p>
            <p>
              You can also add an extra 12 months of extended warranty for $49 before checkout, giving eligible products up to 18 months of voluntary hardware warranty coverage.
            </p>
            <p>
              Value Grade Tech products do not include our voluntary 6-month IT Factory hardware warranty.
            </p>
          `
        },
  
        {
          q: "How long is the standard warranty period?",
  
          a: `
            <p>
              Our standard voluntary IT Factory hardware warranty is 6 months for eligible hardware-related faults.
            </p>
            <p>
              If you add the 12-month extended warranty option for $49, eligible products can have up to 18 months of voluntary hardware warranty coverage.
            </p>
          `
        },
  
        {
          q: "Are warranties different for certain device grades?",
  
          a: `
            <p>
              Our standard refurbished grades receive the same voluntary hardware warranty coverage where the product is eligible.
            </p>
            <p>
              Value Grade Tech is a separate range and does not include our voluntary 6-month IT Factory hardware warranty.
            </p>
          `
        },
  
        {
          q: "Does the warranty cover both hardware and software issues?",
  
          a: `
            <p>
              No, the warranty is a hardware warranty only.
            </p>
            <p>
              Software issues, operating system glitches, viruses, compatibility problems, or app-related issues are not covered under the hardware warranty.
            </p>
          `
        },
  
        {
          q: "Are there exclusions or limitations to the warranty?",
  
          a: `
            <p>
              Yes. Our voluntary IT Factory hardware warranty has exclusions and limitations.
            </p>
            <p>
              <span
                class="info-popup"
                data-info='
                  <h3>Voluntary Hardware Warranty Exclusions</h3>
                  <p>Our voluntary hardware warranty does not cover every issue or type of damage.</p>
                  <ul>
                    <li>Software issues, operating system glitches, viruses, or compatibility problems</li>
                    <li>Accidental or physical damage caused after delivery</li>
                    <li>Cosmetic wear that occurs after delivery</li>
                    <li>Normal battery degradation from use</li>
                    <li>Water or liquid damage</li>
                    <li>Unauthorised repairs or modifications</li>
                    <li>Problems caused by misuse or improper handling</li>
                    <li>Claims made outside the applicable voluntary warranty coverage period</li>
                    <li>Value Grade Tech products</li>
                  </ul>
                '
              >
                View warranty exclusions
              </span>
            </p>
            <p>
              Battery-related claims are assessed based on the nature of the fault, the battery condition disclosed at purchase and the individual circumstances.
            </p>
            <p>
              You can review our <a href="https://itfactoryaustralia.com.au/policies/refund-policy">returns and warranty policy</a> for more details.
            </p>
          `
        },
  
        {
          q: "Can I extend my device warranty?",
  
          a: `
            <p>
              Yes, you can add an extra 12 months of extended warranty for $49 before checkout.
            </p>
            <p>
              This gives eligible products a total of 18 months of hardware warranty coverage.
            </p>
            <p>
              The extended warranty option can be added from the cart page before checkout and is not available for Value Grade Tech range products.
            </p>
          `
        },
  
        {
          q: "How do I know if my device is still under warranty?",
  
          a: `
            <p>
              You can check your order date and the warranty certificate we send you, which includes the warranty expiry date.
            </p>
            <p>
              If you are unsure, contact us with your order number and we can help check your warranty status.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Making a Warranty Claim",
  
      questions: [
  
        {
          q: "How do I make a warranty claim?",
  
          a: `
            <p>
              To make a warranty claim, contact IT Factory Australia support with your order number and a clear description of the issue.
            </p>
            <p>
              Please include photos or videos where helpful, and let us know any troubleshooting steps you have already tried.
            </p>
            <p>
              We will review the information, assess the claim, and let you know the next steps.
            </p>
          `
        },
  
        {
          q: "What information or documents are required to process a warranty claim?",
  
          a: `
            <p>
              To help us process your warranty claim, please provide your order number, invoice, device serial number, issue description, photos or videos, and any troubleshooting steps you have already tried.
            </p>
          `
        },
  
        {
          q: "How long does it take to process a warranty claim?",
  
          a: `
            <p>
              Warranty claim timing depends on the issue and what needs to be assessed.
            </p>
            <p>
              Assessment begins after we receive the required details or the device itself, if the device needs to be returned for inspection.
            </p>
          `
        },
  
        {
          q: "Can I claim warranty for a device purchased in-store or online?",
  
          a: `
            <p>
              IT Factory Australia is an online ecommerce store, so warranty applies to eligible purchases made through our online store.
            </p>
            <p>
              If your order was collected by appointment, the same eligible online warranty process still applies.
            </p>
          `
        },
  
        {
          q: "Who do I contact if my warranty claim is rejected?",
  
          a: `
            <p>
              If your warranty claim is rejected and you want it reviewed, you can reply to our support team and request a review.
            </p>
            <p>
              You can also email <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a> or call <a href="tel:1300589579">1300 589 579</a> and select option 1.
            </p>
          `
        },
  
        {
          q: "What happens if my device cannot be repaired under warranty?",
  
          a: `
            <p>
              When lodging your claim, you can tell us whether your preferred outcome is a repair, replacement or refund.
            </p>
            <p>
              We will assess the device and the circumstances of the claim before determining the appropriate outcome.
            </p>
            <p>
              Under our voluntary IT Factory hardware warranty, we will generally repair the product where practical, provide a suitable replacement where appropriate, or provide a refund where repair or replacement is not appropriate.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Returns Policy",
  
      questions: [
  
        {
          q: "Can I return a product if I change my mind?",
  
          a: `
            <p>
              Yes. Eligible products can be returned for change of mind within 30 days of the original purchase date.
            </p>
            <p>
              You are responsible for arranging and paying the return shipping costs for a change-of-mind return.
            </p>
            <p>
              The product must be returned in the same condition in which it was received, with no additional damage, marks, faults or missing parts. All supplied accessories and included items must also be returned, with original packaging where reasonably applicable.
            </p>
            <p>
              Value Grade Tech products are excluded from our voluntary 30-day change-of-mind return policy.
            </p>
          `
        },
  
        {
          q: "What is the time frame for returning a product?",
  
          a: `
            <p>
              Eligible change-of-mind returns must be requested within 30 days of the original purchase date.
            </p>
            <p>
              Claims under our standard voluntary IT Factory hardware warranty can be made during the applicable 6-month warranty period, or during the extended coverage period if an additional warranty was purchased.
            </p>
          `
        },
  
        {
          q: "Are there any products that cannot be returned?",
  
          a: `
            <p>
              Value Grade Tech products are excluded from our voluntary 30-day change-of-mind return policy.
            </p>
            <p>
              <span
                class="info-popup"
                data-info='
                  <h3>Change-of-Mind Return Conditions</h3>
                  <p>For an eligible change-of-mind return:</p>
                  <ul>
                    <li>The request must be made within 30 days of the original purchase date</li>
                    <li>The product must be returned in the same condition in which it was received</li>
                    <li>There must be no additional damage, marks, faults or missing parts caused after delivery</li>
                    <li>All supplied accessories, components and included items must be returned</li>
                    <li>Original packaging should be included where reasonably applicable</li>
                    <li>Value Grade Tech products are excluded</li>
                  </ul>
                  <p>Other sale, promotional or discounted products remain eligible unless they are identified as Value Grade.</p>
                '
              >
                View change-of-mind return conditions
              </span>
            </p>
            <p>
              Review our <a href="https://itfactoryaustralia.com.au/policies/refund-policy">Refund Policy</a> for full details.
            </p>
          `
        },
  
        {
          q: "Can I return a device that has been partially used?",
  
          a: `
            <p>
              A standard eligible product may still qualify for a change-of-mind return if the request is within 30 days and the product remains in the same condition in which it was received.
            </p>
            <p>
              It must have no additional damage, marks, faults or missing parts caused after delivery. All supplied accessories and included items must be returned, with original packaging where reasonably applicable.
            </p>
            <p>
              Value Grade Tech products are excluded from the voluntary 30-day change-of-mind return policy.
            </p>
          `
        },
  
        {
          q: "How do I initiate a return?",
  
          a: `
            <p>
              Contact IT Factory Australia support before sending anything back so we can review your request and provide the appropriate return instructions.
            </p>
            <p>
              For change-of-mind returns, you are responsible for arranging and paying the return shipping costs.
            </p>
            <p>
              For warranty or faulty-product claims, return arrangements depend on the circumstances and assessment of the issue.
            </p>
          `
        },
  
        {
          q: "Do I need to include original packaging and accessories when returning a device?",
  
          a: `
            <p>
              For a change-of-mind return, all supplied accessories, components and included items must be returned. Original packaging should also be included where reasonably applicable.
            </p>
            <p>
              Please contact us before returning any product so we can provide the correct instructions for your situation.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Replacement & Refunds",
  
      questions: [
  
        {
          q: "Can I exchange a product instead of getting a refund?",
  
          a: `
            <p>
              We do not offer direct exchanges for change-of-mind returns.
            </p>
            <p>
              If your change-of-mind return is approved, you may place a new order separately once the return has been resolved or refunded.
            </p>
            <p>
              Replacement devices may be approved for warranty-related claims, depending on assessment and available stock.
            </p>
          `
        },
  
        {
          q: "How long does it take to receive a replacement device?",
  
          a: `
            <p>
              Replacement timing depends on the warranty assessment and available stock.
            </p>
            <p>
              Once your claim is reviewed, we will let you know what replacement options are available and the expected timing.
            </p>
          `
        },
  
        {
          q: "How long does it take to receive a refund?",
  
          a: `
            <p>
              Once a returned product has been received, inspected and approved, we aim to process the refund within 10 business days.
            </p>
            <p>
              Approved refunds are returned to the original payment method. Your bank, card provider or payment service may require additional processing time before the funds appear.
            </p>
            <p>
              If more than 15 business days have passed since we confirmed that your refund was approved and you have not received it, please contact us.
            </p>
          `
        },
  
        {
          q: "Will I be refunded the full purchase price, including shipping?",
  
          a: `
            <p>
              For an approved change-of-mind return, the eligible product purchase price is refunded to the original payment method.
            </p>
            <p>
              Any optional additional delivery charge, such as an agreed express shipping fee, is not refundable as part of a change-of-mind return.
            </p>
            <p>
              Faulty-product return costs are handled separately. If a product is confirmed to have a problem covered by applicable consumer guarantees, reasonable return costs will be handled or reimbursed as required by the Australian Consumer Law.
            </p>
          `
        },
  
        {
          q: "Can I request a replacement for a different device?",
  
          a: `
            <p>
              You can request this, but it is handled case-by-case.
            </p>
            <p>
              If a different device is approved as part of a warranty-related resolution, any price difference will be handled manually.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Damaged or Faulty Devices",
  
      questions: [
  
        {
          q: "What should I do if my device arrives damaged?",
  
          a: `
            <p>
              Please take clear photos of the device and packaging, keep the packaging where possible, and contact IT Factory Australia support as soon as possible.
            </p>
            <p>
              We will assess the issue and provide the appropriate next steps based on the circumstances of the order.
            </p>
          `
        },
  
        {
          q: "What should I do if my device stops working shortly after purchase?",
  
          a: `
            <p>
              Try basic troubleshooting first, such as restarting the device, checking power and confirming connected accessories are working correctly.
            </p>
            <p>
              If the issue continues, contact us with your order number, a description of the problem and any helpful photos or videos.
            </p>
            <p>
              We will assess whether the issue is covered by our voluntary hardware warranty, or another applicable support process.
            </p>
          `
        },
  
        {
          q: "Who covers shipping costs for returning a faulty device?",
  
          a: `
            <p>
              Please contact IT Factory Australia before returning a faulty product so we can provide the appropriate return instructions.
            </p>
            <p>
              For eligible voluntary warranty claims, we may provide a return label or other return instructions depending on the circumstances.
            </p>
          `
        },
  
        {
          q: "Can I get a replacement device while my warranty claim is being processed?",
  
          a: `
            <p>
              Replacement devices are not provided before assessment.
            </p>
            <p>
              If a replacement is approved after assessment, we will let you know the available options and next steps.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Business & Bulk Orders",
  
      questions: [
  
        {
          q: "Are warranties different for business or bulk purchases?",
  
          a: `
            <p>
              Business and bulk purchases receive the same warranty coverage as eligible regular orders.
            </p>
            <p>
              If any special terms apply to a specific business or bulk order, they will be discussed as part of the order process.
            </p>
          `
        },
  
        {
          q: "Can businesses return multiple items at once?",
  
          a: `
            <p>
              Yes, businesses can request to return multiple items at once after contacting support and receiving approval.
            </p>
            <p>
              Please do not send multiple items back before we confirm the return instructions.
            </p>
          `
        },
  
        {
          q: "How are bulk returns or exchanges handled?",
  
          a: `
            <p>
              Bulk returns are handled through our support team.
            </p>
            <p>
              Please contact us with your order number, item list, serial numbers, issue details, and photos where relevant.
            </p>
            <p>
              We will review the request and provide approval and return instructions if the return is eligible.
            </p>
          `
        }
  
      ]
    }
  
  ],
  
  "Support & Troubleshooting": [
  
    {
      sub: "Getting Technical Support",
  
      questions: [
  
        {
          q: "How do I contact IT Factory Australia for technical support?",
  
          a: `
            <p>
              You can contact IT Factory Australia for technical support by email, phone, or through our contact page.
            </p>
            <p>
              Email <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a> or call <a href="tel:1300589579">1300 589 579</a> and select option 1.
            </p>
            <p>
              Technical support is available for devices purchased from IT Factory Australia.
            </p>
          `
        },
  
        {
          q: "Do you offer support via phone, email, or in-store appointments?",
  
          a: `
            <p>
              Yes, support is available by phone and email.
            </p>
            <p>
              Appointment-only warehouse visits may be arranged when needed, but you must contact us first and wait for confirmation before visiting.
            </p>
            <p>
              Remote support may also be offered if it is suitable for your issue.
            </p>
          `
        },
  
        {
          q: "What are your technical support hours?",
  
          a: `
            <p>
              Technical support is available Monday to Friday, 8:30am to 4:00pm Sydney time.
            </p>
            <p>
              If you contact us outside these hours, we will respond as soon as possible during business hours.
            </p>
          `
        },
  
        {
          q: "Is technical support available for both consumers and businesses?",
  
          a: `
            <p>
              Yes, technical support is available for both personal and business purchases from IT Factory Australia.
            </p>
            <p>
              Support is handled the same way for consumers and businesses, although business or bulk order support may involve extra order details.
            </p>
          `
        },
  
        {
          q: "Are there any fees for technical support?",
  
          a: `
            <p>
              Technical support is free for devices purchased from IT Factory Australia.
            </p>
            <p>
              If your device needs an out-of-warranty repair, replacement part, upgrade, or additional service, we will assess the issue and let you know if any cost applies before proceeding.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Device Setup & Configuration",
  
      questions: [
  
        {
          q: "How do I set up my refurbished device for first use?",
  
          a: `
            <p>
              Start by charging the device, turning it on, connecting to Wi-Fi, and signing in with your account details.
            </p>
            <p>
              After setup, check for system updates and test the basics, such as Wi-Fi, sound, charging, keyboard, touchpad, screen, and any included accessories.
            </p>
            <p>
              If you need help, contact IT Factory Australia support.
            </p>
          `
        },
  
        {
          q: "How do I connect my device to Wi-Fi or mobile networks?",
  
          a: `
            <p>
              On Windows, open your network settings and choose your Wi-Fi network.
            </p>
            <p>
              On Mac, select the Wi-Fi icon or open system settings to connect to your network.
            </p>
            <p>
              On mobile devices, open the Wi-Fi or mobile network settings and follow the prompts for your device.
            </p>
            <p>
              If your device was purchased from IT Factory Australia and you need help, contact our support team.
            </p>
          `
        },
  
        {
          q: "How do I restore or transfer data from my old device?",
  
          a: `
            <p>
              Data transfer help may be available for devices purchased from IT Factory Australia.
            </p>
            <p>
              This is free, appointment-only, and handled case-by-case depending on the device, data type, and support required.
            </p>
            <p>
              Please contact us first so we can confirm whether we can assist.
            </p>
          `
        },
  
        {
          q: "Can IT Factory Australia help with software installation or updates?",
  
          a: `
            <p>
              Yes, we can help with software installation or updates when the request is approved and suitable for the device.
            </p>
            <p>
              This may include operating system updates, drivers, general apps, or other requested software support.
            </p>
            <p>
              Paid software or licences are not included unless they are clearly stated with the product.
            </p>
          `
        },
  
        {
          q: "How do I configure email or cloud accounts on my device?",
  
          a: `
            <p>
              For email or cloud accounts, it is best to follow the setup instructions from your email or cloud provider.
            </p>
            <p>
              If your device was purchased from IT Factory Australia and you need general setup guidance, you can contact us for help.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Troubleshooting Common Issues",
  
      questions: [
  
        {
          q: "My device won’t turn on – what should I do?",
  
          a: `
            <p>
              First, charge the device, check the charger, try another power outlet, and remove any connected accessories.
            </p>
            <p>
              You can also try holding the power button for a few seconds to see if the device responds.
            </p>
            <p>
              If the device still will not turn on, contact IT Factory Australia support before attempting any repair.
            </p>
          `
        },
  
        {
          q: "My device is running slow – how can I improve performance?",
  
          a: `
            <p>
              Try restarting the device, checking for updates, freeing up storage space, closing unused apps, and checking startup apps.
            </p>
            <p>
              You can also run a malware or security scan if the device is behaving unusually.
            </p>
            <p>
              If the issue continues, contact us for support.
            </p>
          `
        },
  
        {
          q: "The battery isn’t charging properly – what can I do?",
  
          a: `
            <p>
              Check the charger, cable, power outlet, and charging port. You can also restart the device and make sure it is not overheating.
            </p>
            <p>
              If the device still does not charge properly, stop using it if it seems unsafe and contact IT Factory Australia support.
            </p>
          `
        },
  
        {
          q: "My device is overheating – what are the recommended solutions?",
  
          a: `
            <p>
              If the device becomes very hot, stop using it and allow it to cool down safely.
            </p>
            <p>
              Use the device on a hard flat surface, check that ventilation is not blocked, close heavy apps, and install available system updates.
            </p>
            <p>
              If overheating continues, contact IT Factory Australia support before attempting any repair.
            </p>
          `
        },
  
        {
          q: "How do I fix connectivity issues (Wi-Fi, Bluetooth, or mobile data)?",
  
          a: `
            <p>
              Try restarting the device, turning the connection off and on again, forgetting and reconnecting to the network, and checking your router or mobile service.
            </p>
            <p>
              You can also check for system or driver updates.
            </p>
            <p>
              If the issue continues on a device purchased from IT Factory Australia, contact us for support.
            </p>
          `
        },
  
        {
          q: "How do I reset my device to factory settings?",
  
          a: `
            <p>
              A factory reset can erase your personal data, so back up anything important before continuing.
            </p>
            <p>
              <span
                class="info-popup"
                data-info='
                  <h3>Factory Reset Guidance</h3>
                  <p>Before resetting, back up your files, sign out of important accounts, and make sure you know any passwords needed after the reset.</p>
  
                  <h4>Windows</h4>
                  <p>Open Settings, go to System, then Recovery, and choose the reset option that suits your needs.</p>
  
                  <h4>Mac</h4>
                  <p>Open System Settings and look for the erase or transfer reset option available for your macOS version.</p>
  
                  <h4>iPhone or iPad</h4>
                  <p>Open Settings, go to General, then Transfer or Reset, and choose the erase option if you want to fully reset the device.</p>
  
                  <h4>Android</h4>
                  <p>Open Settings and search for reset options. The exact wording can vary depending on the device brand.</p>
  
                  <p>If your device is still under warranty or you are unsure, contact IT Factory Australia support before resetting.</p>
                '
              >
                View factory reset guidance
              </span>
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Software & Apps",
  
      questions: [
  
        {
          q: "Do refurbished devices come with pre-installed software?",
  
          a: `
            <p>
              Refurbished devices usually come with the operating system, standard default apps, and required drivers.
            </p>
            <p>
              Paid software is not included unless it is clearly stated on the product listing.
            </p>
          `
        },
  
        {
          q: "Can I install new apps or software on my device?",
  
          a: `
            <p>
              Yes, you can install new apps or software as long as the device meets the software requirements.
            </p>
            <p>
              Before installing anything, check the software requirements for operating system, storage, memory, processor, and compatibility.
            </p>
          `
        },
  
        {
          q: "How do I update the device operating system?",
  
          a: `
            <p>
              On Windows, check for updates through Windows Update.
            </p>
            <p>
              On macOS, check for updates through System Settings or Software Update.
            </p>
            <p>
              On iPhone, iPad, or Android devices, check for updates in the device settings.
            </p>
            <p>
              If you need help with a device purchased from IT Factory Australia, contact our support team.
            </p>
          `
        },
  
        {
          q: "Can IT Factory Australia assist with app-related issues?",
  
          a: `
            <p>
              We can help with basic app-related guidance and device-related troubleshooting when needed.
            </p>
            <p>
              For third-party app account issues, subscriptions, passwords, or app-specific faults, you may also need to contact the app provider directly.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Repairs & Hardware Issues",
  
      questions: [
  
        {
          q: "Do you provide repair services for devices outside warranty?",
  
          a: `
            <p>
              Out-of-warranty repair support may be available case-by-case for devices purchased from IT Factory Australia.
            </p>
            <p>
              Please contact us with the issue and your order details so we can assess whether we can help.
            </p>
          `
        },
  
        {
          q: "How do I get my device repaired at IT Factory Australia?",
  
          a: `
            <p>
              Contact IT Factory Australia support with your order number and a clear description of the issue.
            </p>
            <p>
              We will assess the issue and let you know the next steps. If the device is outside warranty, we may provide a quote before any repair proceeds.
            </p>
            <p>
              <span
                class="info-popup"
                data-info='
                  <h3>Repair Request Steps</h3>
                  <ol>
                    <li>Contact support with your order number and issue details.</li>
                    <li>Provide photos or videos if they help explain the fault.</li>
                    <li>Wait for our assessment instructions.</li>
                    <li>If the device is outside warranty, review and approve any quote before repair work begins.</li>
                    <li>Once approved, we will repair, return, or advise the next suitable option.</li>
                  </ol>
                '
              >
                View repair request steps
              </span>
            </p>
          `
        },
  
        {
          q: "How long do repairs usually take?",
  
          a: `
            <p>
              Repair timing varies depending on the issue, parts availability, assessment requirements, and whether the device is under warranty.
            </p>
            <p>
              Once we review your device or issue details, we will give you a clearer update on the expected timing.
            </p>
          `
        },
  
        {
          q: "Are repairs done in-store or sent to a service centre?",
  
          a: `
            <p>
              Repairs are usually handled at our warehouse by our technicians, or remotely if the issue can be resolved without the device being physically assessed.
            </p>
            <p>
              We will let you know the best support option after reviewing your issue.
            </p>
          `
        },
  
        {
          q: "Can I replace a faulty component myself?",
  
          a: `
            <p>
              We recommend contacting IT Factory Australia before attempting any self-repair or part replacement.
            </p>
            <p>
              Self-repair or unauthorised repair can affect your warranty, especially if the device is damaged or modified during the process.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Data & Security",
  
      questions: [
  
        {
          q: "How can I protect my personal data on a refurbished device?",
  
          a: `
            <p>
              Use strong passwords, keep the device updated, enable a device lock, turn on two-factor authentication for your personal accounts where available, and keep regular backups.
            </p>
            <p>
              You can also use trusted antivirus or security tools where suitable for your device.
            </p>
          `
        },
  
        {
          q: "How do I wipe my old device before trading it in or returning it?",
  
          a: `
            <p>
              Wiping a device can erase your personal data, so back up anything important before you begin.
            </p>
            <p>
              <span
                class="info-popup"
                data-info='
                  <h3>Before Wiping Your Device</h3>
                  <ol>
                    <li>Back up your important files, photos, documents, and account data.</li>
                    <li>Sign out of personal accounts such as Apple ID, Google, Microsoft, email, and cloud services.</li>
                    <li>Remove the device from cloud tracking services where applicable.</li>
                    <li>Perform a factory reset using the device settings.</li>
                    <li>Check that your personal data has been removed before returning, trading, or handing over the device.</li>
                  </ol>
                  <p>If you are unsure, contact support before sending the device back.</p>
                '
              >
                View device wipe checklist
              </span>
            </p>
          `
        },
  
        {
          q: "What should I do if my device is lost or stolen?",
  
          a: `
            <p>
              Use tools such as Find My, Find My Device, or your device tracking service if available.
            </p>
            <p>
              You should also change important passwords, secure your email and cloud accounts, contact your mobile carrier if relevant, and report the device to police if needed.
            </p>
          `
        },
  
        {
          q: "Can IT Factory Australia help recover lost data?",
  
          a: `
            <p>
              IT Factory Australia does not provide guaranteed data recovery services.
            </p>
            <p>
              If data has been deleted, corrupted, or lost, you may need to contact a specialist data recovery provider.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Advanced Support",
  
      questions: [
  
        {
          q: "Can IT Factory Australia help with device upgrades?",
  
          a: `
            <p>
              Device upgrades may be available case-by-case if approved, depending on the device, compatibility, parts, stock, and availability.
            </p>
            <p>
              If you are interested in an upgrade, contact us with your order details and the upgrade you are considering.
            </p>
          `
        },
  
        {
          q: "Do you provide guidance for using accessories or peripherals?",
  
          a: `
            <p>
              Yes, we can provide general guidance for accessories and peripherals such as monitors, keyboards, mice, chargers, docks, cables, printers, and other compatible devices.
            </p>
            <p>
              If you are unsure whether an accessory will work with your device, contact us before purchasing or connecting it.
            </p>
          `
        },
  
        {
          q: "Are there tutorials or guides for using refurbished devices?",
  
          a: `
            <p>
              You can contact IT Factory Australia support if you need help using a refurbished device purchased from us.
            </p>
            <p>
              We can provide general guidance and point you in the right direction where possible.
            </p>
          `
        }
  
      ]
    }
  
  ],
  
  "Product Info & Care": [
  
    {
      sub: "Product Details",
  
      questions: [
  
        {
          q: "How do I check the specifications of a product before purchasing?",
  
          a: `
            <p>
              You can check the product title, product description, images, variant options, specifications table, and product details shown on the listing page.
            </p>
            <p>
              The product listing should be treated as the main source of truth for specs, condition, grade, included accessories, operating system, and product-specific details.
            </p>
          `
        },
  
        {
          q: "What does “refurbished” mean at IT Factory Australia?",
  
          a: `
            <p>
              Refurbished means the device has been professionally checked, tested, cleaned, data-wiped, graded, repaired if needed, and prepared for resale.
            </p>
            <p>
              <span
                class="info-popup"
                data-info='
                  <h3>Our Refurbishment Process</h3>
                  <p>Refurbished tech is prepared so you can buy with more confidence than ordinary second-hand buying.</p>
                  <ol>
                    <li>The device is checked and inspected.</li>
                    <li>Previous data is wiped where applicable.</li>
                    <li>Key hardware functions are tested.</li>
                    <li>The device is cleaned and prepared for resale.</li>
                    <li>Repairs are completed if needed and suitable.</li>
                    <li>The device is graded based on condition.</li>
                    <li>A final quality check is completed before listing or dispatch.</li>
                  </ol>
                '
              >
                View our refurbishment process
              </span>
            </p>
          `
        },
  
        {
          q: "Are all devices fully tested before sale?",
  
          a: `
            <p>
              Yes, devices are tested before sale so you can buy with confidence.
            </p>
            <p>
              Checks may include power, screen, keyboard, trackpad, ports, Wi-Fi, battery, storage, operating system, and a final quality check before dispatch.
            </p>
          `
        },
  
        {
          q: "How do I know if a device has any cosmetic damage?",
  
          a: `
            <p>
              Check the product grade, condition label, product photos, product description, and any condition notes shown on the product listing.
            </p>
            <p>
              You can also review our <a href="https://itfactoryaustralia.com.au/pages/product-grades">grading guide</a> for more detail on what each grade means.
            </p>
          `
        },
  
        {
          q: "Are accessories included with refurbished devices?",
  
          a: `
            <p>
              Included accessories vary by product type and listing.
            </p>
            <p>
              Laptops usually include a charger, desktops usually include a power cable, monitors usually include a stand and power cable, and phones or tablets usually include a cable.
            </p>
            <p>
              Accessories can vary, so always check the <strong>What’s Included</strong> tab in the product specifications table before purchasing.
            </p>
          `
        },
  
        {
          q: "Can I request additional photos or information about a device?",
  
          a: `
            <p>
              Yes, you can contact us to request additional information or photos for a product.
            </p>
            <p>
              We can provide this sometimes for requested products, depending on the item and availability.
            </p>
            <p>
              Email <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a> if you need more detail before purchasing.
            </p>
          `
        },
  
        {
          q: "How do I compare different grades of refurbished devices?",
  
          a: `
            <p>
              Device grades help you compare cosmetic condition and value before purchasing.
            </p>
            <p>
              Grade A is best for cosmetic condition, Grade B is a balanced choice, Grade B- and C+ may show more visible wear while still offering value, Grade C is more budget-focused, and Grade D or Value Grade Tech is usually for clearance or heavier wear.
            </p>
            <p>
              For a more detailed breakdown, view our <a href="https://itfactoryaustralia.com.au/pages/product-grades">grading guide</a>.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Device Care & Maintenance",
  
      questions: [
  
        {
          q: "How do I properly clean my refurbished device?",
  
          a: `
            <p>
              Power off and unplug the device before cleaning it.
            </p>
            <p>
              Use a soft microfiber cloth, clean gently, avoid harsh chemicals, and keep liquid away from ports, vents, screens, keyboards, and charging areas.
            </p>
          `
        },
  
        {
          q: "What is the best way to charge my device to extend battery life?",
  
          a: `
            <p>
              Use the correct charger, avoid extreme heat, avoid fully draining the battery too often, and do not keep using the device if it is overheating.
            </p>
            <p>
              Keeping your software updated can also help with battery performance and power management.
            </p>
          `
        },
  
        {
          q: "How do I prevent overheating or other hardware issues?",
  
          a: `
            <p>
              Use your device on a hard flat surface, keep vents clear, avoid soft surfaces like beds or cushions, close heavy apps when not needed, and keep your system updated.
            </p>
            <p>
              If the device becomes very hot, stop using it and let it cool down safely before continuing.
            </p>
          `
        },
  
        {
          q: "Can I use third-party accessories safely with my device?",
  
          a: `
            <p>
              Yes, you can use third-party accessories if they are compatible, good quality, and suitable for your device.
            </p>
            <p>
              Be careful with cheap or unsafe chargers, cables, and adapters. Always check the connector type, wattage, power rating, and model compatibility before use.
            </p>
          `
        },
  
        {
          q: "How should I store my device when not in use?",
  
          a: `
            <p>
              Store your device in a cool, dry place away from heat, moisture, direct sunlight, and heavy pressure.
            </p>
            <p>
              For battery-powered devices, avoid storing them completely flat for long periods. A partial charge is usually better for longer storage.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Upgrades & Modifications",
  
      questions: [
  
        {
          q: "Can I upgrade memory, storage, or other components on a refurbished device?",
  
          a: `
            <p>
              Upgrades may be available through IT Factory Australia before or after purchase.
            </p>
            <p>
              Availability depends on the device, compatibility, stock, parts, and whether the upgrade is approved for that model.
            </p>
            <p>
              If you are interested in an upgrade, contact us before making changes yourself.
            </p>
          `
        },
  
        {
          q: "Will upgrades affect my warranty?",
  
          a: `
            <p>
              ITF-approved upgrades are okay when they are completed or approved by us.
            </p>
            <p>
              Self-upgrades, unauthorised repairs, or unauthorised modifications may affect your warranty, especially if the device is damaged or altered during the process.
            </p>
          `
        },
  
        {
          q: "Can I replace parts myself, or should I get professional assistance?",
  
          a: `
            <p>
              We strongly recommend contacting IT Factory Australia before replacing parts yourself, especially while the device is under warranty.
            </p>
            <p>
              DIY repairs or unauthorised part replacements may affect warranty coverage and can create further hardware issues if the wrong part is used.
            </p>
          `
        },
  
        {
          q: "Do you offer guidance for upgrading devices?",
  
          a: `
            <p>
              Yes, we can offer upgrade guidance and upgrade services case-by-case.
            </p>
            <p>
              This depends on the device model, compatibility, available parts, stock, and whether the upgrade is suitable.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Software & Performance",
  
      questions: [
  
        {
          q: "Are refurbished devices updated to the latest operating system?",
  
          a: `
            <p>
              Devices are prepared with the latest compatible operating system where possible, unless stated otherwise in the product description.
            </p>
            <p>
              Some older models may only support certain operating system versions, so always check the product listing before purchasing.
            </p>
          `
        },
  
        {
          q: "Can I reinstall the original operating system or restore factory settings?",
  
          a: `
            <p>
              Yes, but a reinstall or factory reset can erase your personal data.
            </p>
            <p>
              Back up anything important first, sign out of your accounts where needed, and contact IT Factory Australia support before resetting if you are unsure.
            </p>
          `
        },
  
        {
          q: "How do I keep my device running smoothly over time?",
  
          a: `
            <p>
              Keep your device updated, leave enough free storage space, restart it regularly, close unused apps, run security scans, and avoid unsafe downloads.
            </p>
            <p>
              For laptops and desktops, keeping vents clear can also help performance and reduce overheating.
            </p>
          `
        },
  
        {
          q: "Are there recommended apps or software for refurbished devices?",
  
          a: `
            <p>
              Recommended software depends on how you plan to use the device.
            </p>
            <p>
              Useful categories may include security tools, a trusted browser, cloud backup, office or productivity apps, and manufacturer update tools where suitable.
            </p>
            <p>
              Before installing software, check that your device meets the software requirements.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Product Comparisons",
  
      questions: [
  
        {
          q: "How do I choose between different grades (A, B, C, D) of devices?",
  
          a: `
            <p>
              Choose based on how much cosmetic wear you are comfortable with and how much value you want from the device.
            </p>
            <p>
              Grade A is best if you want the cleanest cosmetic condition, Grade B is a balanced choice, Grade C is better for budget-focused value, and Grade D or Value Grade Tech is generally suited to clearance, heavier wear, or more limited condition expectations.
            </p>
          `
        },
  
        {
          q: "What is the difference between refurbished and “like new” devices?",
  
          a: `
            <p>
              Refurbished describes the process of checking, testing, cleaning, grading, and preparing a device for resale.
            </p>
            <p>
              “Like new” is a cosmetic description, not a guarantee that the device is brand new. Always check the product grade, condition, and listing details before purchasing.
            </p>
          `
        },
  
        {
          q: "How do I decide between refurbished and new devices?",
  
          a: `
            <p>
              Refurbished devices can be a strong choice if you want lower pricing, tested hardware, warranty protection, better value, and a more sustainable way to buy tech.
            </p>
            <p>
              New devices may suit you better if you want the latest model, untouched condition, or manufacturer-new packaging. Refurbished is ideal when you want practical value and are comfortable with realistic cosmetic expectations.
            </p>
          `
        },
  
        {
          q: "Are there features missing in certain refurbished models?",
  
          a: `
            <p>
              Yes, features can vary by model, year, generation, and specifications.
            </p>
            <p>
              Before purchasing, check the listing for details such as ports, operating system support, webcam, touchscreen, battery, storage, memory, processor, Wi-Fi, Bluetooth, and network compatibility.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Special Considerations",
  
      questions: [
  
        {
          q: "Are refurbished devices suitable for business or corporate use?",
  
          a: `
            <p>
              Yes, refurbished devices can be suitable for business or corporate use, especially business-grade laptops, desktops, and monitors.
            </p>
            <p>
              Suitability depends on the specs, quantity, grade, condition, software needs, and business requirements.
            </p>
            <p>
              If you are buying for a business, contact us for help choosing the right setup.
            </p>
          `
        },
  
        {
          q: "Can I buy devices for educational or institutional purposes?",
  
          a: `
            <p>
              Yes, you can buy devices for students, schools, TAFEs, universities, and other institutions.
            </p>
            <p>
              For bulk orders, quotes, or specific requirements, email <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a> so we can help review your needs.
            </p>
          `
        },
  
        {
          q: "How do I check if a device is compatible with my network or software requirements?",
  
          a: `
            <p>
              Start by checking the product listing against the requirements for your software, network, or workplace setup.
            </p>
            <p>
              If you need help, contact us with the software name, minimum requirements, operating system needs, RAM, storage, processor, ports, Wi-Fi or network needs, and quantity required.
            </p>
          `
        }
  
      ]
    }
  
  ],
  
  "Payments & Pricing": [
  
    {
      sub: "Payment Methods",
  
      questions: [
  
        {
          q: "What payment methods are accepted at IT Factory Australia?",
  
          a: `
            <p>
              We currently accept Afterpay, American Express, Apple Pay, Google Pay, Mastercard, Shop Pay, and Visa through our online checkout.
            </p>
            <p>
              Bank transfer may be available only for manually approved special cases, such as deposits.
            </p>
          `
        },
  
        {
          q: "Can I pay with a credit card, debit card, or PayPal?",
  
          a: `
            <p>
              Yes, you can pay with accepted credit and debit cards, including Visa, Mastercard, and American Express.
            </p>
            <p>
              PayPal is not currently available as a payment method at IT Factory Australia.
            </p>
          `
        },
  
        {
          q: "Are there options for installment payments or financing?",
  
          a: `
            <p>
              Yes, Afterpay is currently available as an instalment payment option.
            </p>
            <p>
              Afterpay approval, repayments, limits, and eligibility are managed by Afterpay, so you should review Afterpay’s own terms before choosing it at checkout.
            </p>
          `
        },
  
        {
          q: "Can I pay via bank transfer or direct deposit?",
  
          a: `
            <p>
              Bank transfer is not available as a standard checkout payment method.
            </p>
            <p>
              It may be available for manually approved special cases, such as deposits. Please contact support first if you need to discuss this option.
            </p>
          `
        },
  
        {
          q: "Are there any fees for certain payment methods?",
  
          a: `
            <p>
              IT Factory Australia does not charge extra payment method fees.
            </p>
            <p>
              If you use a third-party payment provider, such as Afterpay, you should review their terms for any provider-specific conditions.
            </p>
          `
        },
  
        {
          q: "Can I split payment between multiple methods?",
  
          a: `
            <p>
              Split payments between multiple payment methods are not currently available through our online checkout.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Invoices & Receipts",
  
      questions: [
  
        {
          q: "How do I get a tax invoice for my purchase?",
  
          a: `
            <p>
              You can download your tax invoice from your order page.
            </p>
            <p>
              If you need help accessing it, contact us at <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a>.
            </p>
          `
        },
  
        {
          q: "Can I receive a digital copy of my receipt or invoice?",
  
          a: `
            <p>
              Yes, your receipt or invoice is available digitally from your order page.
            </p>
            <p>
              If you need another copy, you can contact support and we can help.
            </p>
          `
        },
  
        {
          q: "How do I update my billing information?",
  
          a: `
            <p>
              Billing information cannot be changed after purchase.
            </p>
            <p>
              Please check your billing details carefully before completing checkout.
            </p>
          `
        },
  
        {
          q: "Can invoices be issued to a business instead of an individual?",
  
          a: `
            <p>
              Yes, invoices can be issued to a business.
            </p>
            <p>
              Please contact support with your business name, ABN, contact name, billing email, order number, and any other required invoice details.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Pricing & Promotions",
  
      questions: [
  
        {
          q: "Are the prices displayed inclusive of GST and taxes?",
  
          a: `
            <p>
              Yes, prices displayed on IT Factory Australia are inclusive of GST and taxes.
            </p>
          `
        },
  
        {
          q: "How often do product prices change?",
  
          a: `
            <p>
              Product prices may change based on stock, market value, product condition, availability, sales, or clearance events.
            </p>
            <p>
              The current price shown on the product page is the price available at that time.
            </p>
          `
        },
  
        {
          q: "Are refurbished devices cheaper than new devices?",
  
          a: `
            <p>
              Yes, refurbished devices are generally cheaper than buying new.
            </p>
            <p>
              The final price depends on the model, specifications, condition, grade, availability, and current market value.
            </p>
          `
        },
  
        {
          q: "Do you offer discounts for bulk or corporate orders?",
  
          a: `
            <p>
              Bulk or corporate pricing may be available case-by-case.
            </p>
            <p>
              Please contact us through our contact page or email <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a> to discuss your order requirements.
            </p>
          `
        },
  
        {
          q: "How do I apply promotional codes or vouchers?",
  
          a: `
            <p>
              You can apply promotional codes or vouchers at checkout.
            </p>
            <p>
              Promotional codes may have expiry dates, eligibility rules, or product restrictions, so make sure the code is entered correctly before completing your order.
            </p>
          `
        },
  
        {
          q: "Are there seasonal or clearance sales?",
  
          a: `
            <p>
              Yes, IT Factory Australia may offer seasonal sales, clearance offers, and limited-time promotions.
            </p>
            <p>
              You can also subscribe to our emails and become an ITF Insider to receive exclusive deals that may not be available to the public.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Billing Issues",
  
      questions: [
  
        {
          q: "What should I do if my payment was declined?",
  
          a: `
            <p>
              First, check that your payment details are correct and try another payment method if available.
            </p>
            <p>
              If the issue continues, contact your bank or payment provider. You can also contact IT Factory Australia support if you need help checking whether an order was created.
            </p>
          `
        },
  
        {
          q: "Why was I charged twice for the same order?",
  
          a: `
            <p>
              Sometimes a pending authorisation can appear temporarily before your bank or payment provider releases it.
            </p>
            <p>
              If you believe you have been fully charged twice for the same order, contact support with your order number, amount charged, payment method, date, and a screenshot or statement if available.
            </p>
          `
        },
  
        {
          q: "How do I dispute an incorrect charge?",
  
          a: `
            <p>
              Please contact support with your order number, amount charged, charge date, payment method, and a screenshot or statement if available.
            </p>
            <p>
              We will review the issue and let you know the next steps.
            </p>
          `
        },
  
        {
          q: "Can I get a refund for an overpayment?",
  
          a: `
            <p>
              Yes, an overpayment can be refunded after support verifies the issue.
            </p>
            <p>
              Approved overpayment refunds are returned to the original payment method used for the order where possible.
            </p>
          `
        },
  
        {
          q: "Who do I contact for billing or payment inquiries?",
  
          a: `
            <p>
              For billing or payment inquiries, email our support team at <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a>.
            </p>
            <p>
              Please include your order number and any payment details that may help us review your enquiry.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Special Cases",
  
      questions: [
  
        {
          q: "Can businesses pay using purchase orders?",
  
          a: `
            <p>
              Purchase orders may be available case-by-case for approved business, education, or corporate buyers.
            </p>
            <p>
              Please contact support first to discuss approval before placing an order.
            </p>
          `
        },
  
        {
          q: "Are there special pricing or payment options for educational institutions?",
  
          a: `
            <p>
              Special pricing or payment options may be available case-by-case for schools, TAFEs, universities, and other educational institutions.
            </p>
            <p>
              Please email <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a> to discuss your requirements.
            </p>
          `
        },
  
        {
          q: "Do you provide quotes for bulk or custom orders?",
  
          a: `
            <p>
              Yes, we can provide quotes for bulk or custom orders.
            </p>
            <p>
              To help us prepare an accurate quote, include your name, business or institution name, ABN if available, product type, quantity, specifications, budget, timeframe, and delivery location.
            </p>
          `
        }
  
      ]
    }
  
  ],
  
  "Terms & Policies": [
  
    {
      sub: "General Policies",
  
      questions: [
  
        {
          q: "Where can I read IT Factory Australia’s terms and conditions?",
  
          a: `
            <p>
              You can read our official terms and conditions on our <a href="https://itfactoryaustralia.com.au/policies/terms-of-service">Terms and Conditions page</a>.
            </p>
            <p>
              This page outlines the main rules for using our website, placing orders, payments, product availability, and related services.
            </p>
          `
        },
  
        {
          q: "What are the rules for using the website and services?",
  
          a: `
            <p>
              You should use accurate information, use the website lawfully, follow checkout and payment rules, and avoid any fraudulent, harmful, or misleading activity.
            </p>
            <p>
              You must not misuse the website, interfere with website operation, attempt unauthorised access, or use the website in a way that may affect other users or IT Factory Australia.
            </p>
            <p>
              For full details, please refer to our <a href="https://itfactoryaustralia.com.au/policies/terms-of-service">Terms and Conditions</a>.
            </p>
          `
        },
  
        {
          q: "Are there any restrictions on purchasing refurbished devices?",
  
          a: `
            <p>
              Some restrictions may apply depending on stock availability, payment verification, fraud checks, and order review requirements.
            </p>
            <p>
              Bulk orders must be approved through our support team before being confirmed.
            </p>
            <p>
              If an order is flagged for possible fraud or payment risk, we may request additional information, hold the order, request another payment method, or cancel the order where applicable.
            </p>
          `
        },
  
        {
          q: "How are disputes or complaints handled?",
  
          a: `
            <p>
              If you have a dispute or complaint, please contact IT Factory Australia support first so we can review the issue properly.
            </p>
            <p>
              Include your order number, contact details, a clear description of the issue, and any relevant photos, screenshots, or supporting information.
            </p>
            <p>
              We will review the matter internally and follow up with you by email or phone where needed.
            </p>
          `
        },
  
        {
          q: "What is IT Factory Australia’s policy on product availability?",
  
          a: `
            <p>
              Product availability can change because refurbished stock is often limited and may depend on the exact model, grade, condition, and quantity available.
            </p>
            <p>
              If a product becomes unavailable after you place an order, we will contact you and provide available resolution options.
            </p>
            <p>
              Depending on the situation, this may include an alternative product, refund, store credit, or equivalent model. You will be able to choose the preferred resolution from the options available.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Privacy & Data Protection",
  
      questions: [
  
        {
          q: "How does IT Factory Australia handle my personal information?",
  
          a: `
            <p>
              We use your personal information to help process orders, payments, shipping, support, account management, and marketing communications if you choose to subscribe.
            </p>
            <p>
              You can read more about how your information is handled in our <a href="https://itfactoryaustralia.com.au/policies/privacy-policy">Privacy Policy</a>.
            </p>
          `
        },
  
        {
          q: "Is my payment information secure?",
  
          a: `
            <p>
              Payments are processed through secure third-party payment providers.
            </p>
            <p>
              IT Factory Australia does not store your full card details. Your payment details are handled through the payment method or checkout provider you choose at checkout.
            </p>
          `
        },
  
        {
          q: "Can I request deletion of my personal data?",
  
          a: `
            <p>
              Yes, you can contact IT Factory Australia support to request deletion of your personal data.
            </p>
            <p>
              Some records may still need to be kept where required for order history, warranty, tax, fraud prevention, business record, or legal reasons.
            </p>
            <p>
              Email <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a> if you would like to make a privacy-related request.
            </p>
          `
        },
  
        {
          q: "Do you share my information with third parties?",
  
          a: `
            <p>
              We only share information where needed to provide our services, process orders, arrange delivery, or operate the website.
            </p>
            <p>
              This may include platforms and service providers such as Shopify and courier partners.
            </p>
            <p>
              For more detail, please review our <a href="https://itfactoryaustralia.com.au/policies/privacy-policy">Privacy Policy</a>.
            </p>
          `
        },
  
        {
          q: "How is data stored and protected?",
  
          a: `
            <p>
              We use secure platforms, limit access where appropriate, and take reasonable steps to protect your information.
            </p>
            <p>
              No online system can be guaranteed completely risk-free, but we aim to handle your information carefully and responsibly.
            </p>
            <p>
              You can read more in our <a href="https://itfactoryaustralia.com.au/policies/privacy-policy">Privacy Policy</a>.
            </p>
          `
        },
  
        {
          q: "What cookies or tracking technologies are used on the website?",
  
          a: `
            <p>
              Our website may use cookies and similar technologies to help operate the store, support checkout, improve website performance, and understand website activity.
            </p>
            <p>
              Because our store is powered by Shopify, you can also read Shopify’s cookie information here:
              <a href="https://www.shopify.com/legal/cookies" target="_blank" rel="noopener">Shopify Cookie Policy</a>.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Legal & Compliance",
  
      questions: [
  
        {
          q: "Are refurbished devices compliant with Australian regulations?",
  
          a: `
            <p>
              Devices sold by IT Factory Australia are prepared for resale and sold for use in Australia.
            </p>
            <p>
              We check, test, clean, data-wipe, grade, and prepare refurbished devices before listing or dispatch where applicable.
            </p>
          `
        },
  
        {
          q: "Does IT Factory Australia comply with consumer rights laws?",
  
          a: `
            <p>
              Yes, IT Factory Australia aims to operate in line with applicable consumer rights and business obligations.
            </p>
            <p>
              Our policies are designed to work alongside your rights, including rights that may apply under Australian consumer protection laws.
            </p>
          `
        },
  
        {
          q: "Are warranties and returns compliant with Australian Consumer Law (ACL)?",
  
          a: `
            <p>
              Our warranty and returns processes are designed to work alongside applicable Australian consumer rights.
            </p>
            <p>
              Our store warranty does not replace any rights you may have under Australian Consumer Law where those rights apply.
            </p>
            <p>
              For store-specific return and warranty details, please review our <a href="https://itfactoryaustralia.com.au/policies/refund-policy">Refund Policy</a>.
            </p>
          `
        },
  
        {
          q: "How does IT Factory Australia handle safety recalls?",
  
          a: `
            <p>
              Safety recalls are rare, but if a recall or product safety concern affects an item we have sold, we will review the affected products and contact impacted customers where possible.
            </p>
            <p>
              We will provide next steps based on the product, issue, and available resolution at the time.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Account & Security Policies",
  
      questions: [
  
        {
          q: "What are the rules for creating and maintaining an account?",
  
          a: `
            <p>
              You should provide accurate account details, keep your email account secure, avoid sharing login codes, and use your account responsibly.
            </p>
            <p>
              You are responsible for activity connected to your account and the email address used to access it.
            </p>
          `
        },
  
        {
          q: "How do you handle account misuse or fraudulent activity?",
  
          a: `
            <p>
              If an account or order is flagged for possible misuse, fraud, or payment risk, we may review the order before dispatch.
            </p>
            <p>
              This may include requesting ID, payment verification, another payment method, or additional order details.
            </p>
            <p>
              Where applicable, we may hold or cancel an order, restrict account activity, or contact you for further information.
            </p>
          `
        },
  
        {
          q: "Can IT Factory Australia suspend or terminate an account?",
  
          a: `
            <p>
              Yes, IT Factory Australia may suspend, restrict, or terminate an account where there is misuse, fraudulent activity, security concern, or a breach of our policies.
            </p>
            <p>
              Any action will depend on the situation and may be subject to review.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Shipping & Delivery Policies",
  
      questions: [
  
        {
          q: "What are the shipping terms and conditions?",
  
          a: `
            <p>
              IT Factory Australia provides free standard shipping on all online orders delivered within Australia, with no minimum spend required.
            </p>
            <p>
              Orders are usually dispatched within 1–2 business days after payment, order review and final quality checks are completed. Tracking is provided after dispatch.
            </p>
            <p>
              Express shipping can be requested before dispatch and is assessed individually. An additional charge may apply and will be confirmed before the express arrangement proceeds.
            </p>
            <p>
              Pickup is available from our Wetherill Park location by confirmed appointment only.
            </p>
            <p>
              International delivery is not a standard checkout option and may only be considered case-by-case after contacting us.
            </p>
            <p>
              For full details, please review our <a href="https://itfactoryaustralia.com.au/policies/shipping-policy">Shipping Policy</a>.
            </p>
          `
        },
  
        {
          q: "Who is responsible for lost or damaged shipments?",
  
          a: `
            <p>
              If your shipment is lost, delayed, or damaged, please contact IT Factory Australia support so we can review the issue and investigate with the courier where needed.
            </p>
            <p>
              You may need to provide your order number, tracking details, photos of damage, photos of the packaging, and any courier updates you have received.
            </p>
            <p>
              The outcome will depend on the situation, courier assessment, shipment status, evidence provided, and applicable policy terms.
            </p>
          `
        },
  
        {
          q: "Are there liability limitations for shipping delays?",
  
          a: `
            <p>
              Delivery timeframes are estimates only and are not guaranteed.
            </p>
            <p>
              Once an order has been dispatched, courier delays are outside IT Factory Australia’s direct control.
            </p>
            <p>
              <span
                class="info-popup"
                data-info='
                  <h3>Shipping Delay Limitations</h3>
                  <p>Shipping delays may occur for reasons outside our direct control, including courier network delays, public holidays, sale periods, high-order periods, weather events, remote delivery locations, incorrect address details, missed delivery attempts, courier scanning delays, or depot processing delays.</p>
                  <p>We will help where possible, but we cannot guarantee exact delivery dates once an order is with the courier.</p>
                '
              >
                View shipping delay details
              </span>
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Return & Refund Policies",
  
      questions: [
  
        {
          q: "What is the official returns and refund policy?",
  
          a: `
            <p>
              You can read our full returns, refund and warranty terms in our <a href="https://itfactoryaustralia.com.au/policies/refund-policy">Refund Policy</a>.
            </p>
            <p>
              In general, eligible products can be returned for change of mind within 30 days, with return shipping paid by the customer. Standard eligible products also include our voluntary 6-month hardware warranty.
            </p>
            <p>
              Value Grade Tech products are excluded from both of these voluntary protections.
            </p>
          `
        },
  
        {
          q: "Are there any products excluded from returns?",
  
          a: `
            <p>
              Value Grade Tech products are excluded from our voluntary 30-day change-of-mind return policy.
            </p>
            <p>
              Other sale, promotional or discounted products remain eligible for our voluntary change-of-mind return policy unless they are identified as Value Grade, provided the return conditions are met.
            </p>
            <p>
              Please review our <a href="https://itfactoryaustralia.com.au/policies/refund-policy">Refund Policy</a> before starting a return.
            </p>
          `
        },
  
        {
          q: "How are refunds processed and how long do they take?",
  
          a: `
            <p>
              Refunds are processed after the returned item has been received, reviewed and approved.
            </p>
            <p>
              We aim to process an approved refund within 10 business days. Your bank, card provider or payment service may require additional processing time.
            </p>
            <p>
              Approved refunds are returned to the original payment method.
            </p>
            <p>
              If more than 15 business days have passed since we confirmed that your refund was approved and you have not received it, please contact us.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Business & Bulk Orders",
  
      questions: [
  
        {
          q: "Are there special terms for business or corporate orders?",
  
          a: `
            <p>
              Business, corporate, education, and bulk order terms may vary case-by-case.
            </p>
            <p>
              This may include custom pricing, quotes, purchase orders, net payment terms, bulk returns, warranty handling, delivery arrangements, or special order requirements.
            </p>
            <p>
              Please contact us before placing a business or bulk order so we can review your needs properly.
            </p>
          `
        },
  
        {
          q: "Can business accounts request customized contracts or agreements?",
  
          a: `
            <p>
              Custom contracts or agreements may be available case-by-case for larger business, education, or corporate orders.
            </p>
            <p>
              Please contact support with your organisation details, order requirements, quantity, budget, timeframe, and any contract needs you would like reviewed.
            </p>
          `
        }
  
      ]
    }
  
  ],
  
  "Sustainability": [
  
    {
      sub: "Company Commitment",
  
      questions: [
  
        {
          q: "What is IT Factory Australia’s sustainability commitment?",
  
          a: `
            <p>
              IT Factory Australia is committed to extending the life of technology, reducing e-waste where possible, making refurbished tech more accessible, and supporting smarter tech buying.
            </p>
            <p>
              Our focus is on helping usable devices stay in circulation for longer instead of being replaced too early.
            </p>
            <p>
              You can learn more on our <a href="https://itfactoryaustralia.com.au/pages/our-sustainability-commitment">sustainability commitment page</a>.
            </p>
          `
        },
  
        {
          q: "How does IT Factory Australia reduce electronic waste?",
  
          a: `
            <p>
              We help reduce e-waste by refurbishing devices, repairing suitable products, testing devices before resale, reusing parts where possible, and responsibly handling unusable components.
            </p>
            <p>
              This helps keep more working technology in use for longer.
            </p>
          `
        },
  
        {
          q: "Why should I choose refurbished devices over new ones for sustainability?",
  
          a: `
            <p>
              Choosing refurbished can help extend the life of existing technology, reduce demand for brand-new manufacturing, and keep usable devices out of landfill for longer.
            </p>
            <p>
              It can also give you better value while supporting more responsible tech use.
            </p>
          `
        },
  
        {
          q: "How does IT Factory Australia support a circular economy?",
  
          a: `
            <p>
              We support a circular economy by helping devices move through repair, reuse, resale, parts recovery, and responsible recycling where possible.
            </p>
            <p>
              <span
                class="info-popup"
                data-info='
                  <h3>How Refurbished Tech Supports a Circular Economy</h3>
                  <p>A circular economy focuses on keeping useful products and materials in circulation for longer instead of replacing them too quickly.</p>
                  <ul>
                    <li>Working devices are tested and prepared for resale.</li>
                    <li>Suitable devices may be repaired before listing.</li>
                    <li>Usable parts may be recovered where possible.</li>
                    <li>Devices that cannot be reused are handled through responsible recycling or disposal pathways where available.</li>
                    <li>You help support the cycle by choosing refurbished and caring for your device properly.</li>
                  </ul>
                '
              >
                View how the circular economy works
              </span>
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Refurbishment & Recycling",
  
      questions: [
  
        {
          q: "How are devices refurbished to extend their lifespan?",
  
          a: `
            <p>
              Devices are data-wiped where applicable, tested, cleaned, repaired if needed, graded, final checked, and then listed for resale.
            </p>
            <p>
              This process helps give usable technology a second life while giving you clearer information about the device before purchasing.
            </p>
          `
        },
  
        {
          q: "What happens to devices that cannot be refurbished?",
  
          a: `
            <p>
              Devices that cannot be refurbished may be kept for parts, have reusable parts recovered where possible, sent to recycling partners, or safely disposed of through responsible pathways.
            </p>
            <p>
              We avoid claiming every component can always be reused or recycled, because the right outcome depends on the device, parts, and condition.
            </p>
          `
        },
  
        {
          q: "Can I recycle my old devices through IT Factory Australia?",
  
          a: `
            <p>
              We do not currently offer a standard public recycling or trade-in program through checkout.
            </p>
            <p>
              If you have a device you would like to discuss, you can contact our support team and we can let you know what options may be available.
            </p>
            <p>
              Email <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a>.
            </p>
          `
        },
  
        {
          q: "Are all components safely disposed of or recycled?",
  
          a: `
            <p>
              Reusable parts are recovered where possible, and unusable components are handled responsibly where suitable pathways are available.
            </p>
            <p>
              Not every component can always be reused or recycled, so we keep this process practical and condition-dependent.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Environmental Impact",
  
      questions: [
  
        {
          q: "How does buying refurbished devices help the environment?",
  
          a: `
            <p>
              Buying refurbished can help reduce e-waste, extend the life of existing devices, and reduce the need to buy brand-new tech as often.
            </p>
            <p>
              The Global E-waste Monitor 2024 reported that 62 billion kg of e-waste was generated globally in 2022, and only 22.3% was formally collected and recycled.
            </p>
            <p>
              <a href="https://www.itu.int/en/ITU-D/Environment/Pages/Publications/The-Global-E-waste-Monitor-2024.aspx" target="_blank" rel="noopener">View the Global E-waste Monitor 2024</a>.
            </p>
          `
        },
  
        {
          q: "Does IT Factory Australia use eco-friendly packaging?",
  
          a: `
            <p>
              We do not currently make a formal eco-packaging claim.
            </p>
            <p>
              Where suitable, we may use recyclable packaging, reused packaging, and protective packaging to help keep devices safe in transit.
            </p>
            <p>
              Our priority is to package your order securely so it arrives safely.
            </p>
          `
        },
  
        {
          q: "Are refurbished devices energy-efficient?",
  
          a: `
            <p>
              Energy efficiency depends on the device model, age, specifications, operating system, and how you use it.
            </p>
            <p>
              If energy use is important to you, check the product specifications carefully or contact us before purchasing for general guidance.
            </p>
          `
        },
  
        {
          q: "How do you minimise carbon footprint in shipping and operations?",
  
          a: `
            <p>
              We do not currently operate a formal carbon-neutral shipping or carbon offset program.
            </p>
            <p>
              We focus on practical steps such as free standard Australia-wide shipping, efficient packing, local Australian operations, consolidated processing where possible, and digital invoices.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Sustainable Practices",
  
      questions: [
  
        {
          q: "Does IT Factory Australia support local communities or ethical sourcing?",
  
          a: `
            <p>
              IT Factory Australia supports more responsible tech use by helping Australians access refurbished technology and keeping usable devices in circulation for longer.
            </p>
            <p>
              We keep this commitment practical and will continue reviewing our processes as the business grows.
            </p>
          `
        },
  
        {
          q: "Are there initiatives to reduce plastic and electronic waste?",
  
          a: `
            <p>
              Yes, our main waste-reduction efforts include refurbishment, parts reuse where possible, responsible recycling pathways, digital invoices, and practical packaging choices.
            </p>
            <p>
              We aim to reduce unnecessary waste without making claims that go beyond what our current processes support.
            </p>
          `
        },
  
        {
          q: "How often does IT Factory Australia review or update its sustainability practices?",
  
          a: `
            <p>
              We review and update our sustainability practices as the business grows and our processes improve.
            </p>
            <p>
              Our focus is on practical improvements that help extend device life, reduce avoidable waste, and support more responsible tech buying.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Customer Participation",
  
      questions: [
  
        {
          q: "How can I contribute to IT Factory Australia’s sustainability efforts?",
  
          a: `
            <p>
              You can contribute by choosing refurbished devices, caring for your device properly, recycling old tech responsibly, and choosing the right specifications so your device lasts longer.
            </p>
            <p>
              Small choices like protecting your device, keeping it updated, and avoiding unnecessary upgrades can help extend its usable life.
            </p>
          `
        },
  
        {
          q: "Can I trade in my device to support your refurbishment program?",
  
          a: `
            <p>
              Trade-ins are not currently available as a standard program at IT Factory Australia.
            </p>
            <p>
              If you have a device you would like to discuss, you can contact support and we can let you know whether any option may be available.
            </p>
          `
        },
  
        {
          q: "Are there incentives for customers who participate in recycling or trade-ins?",
  
          a: `
            <p>
              We do not currently offer a standard incentive program for recycling or trade-ins.
            </p>
            <p>
              If this changes in the future, we may share updates through our website, sustainability page, or email updates.
            </p>
          `
        }
  
      ]
    }
  
  ],
  
  "Device Grading System": [
  
    {
      sub: "General Grading Overview",
  
      questions: [
  
        {
          q: "What is the Device Grading System at IT Factory Australia?",
  
          a: `
            <p>
              The Device Grading System helps you understand a device’s cosmetic condition, functional condition, expected wear, and overall value before buying.
            </p>
            <p>
              It gives you a clearer idea of what to expect from refurbished devices across different condition levels.
            </p>
            <p>
              You can also view our <a href="https://itfactoryaustralia.com.au/pages/product-grades">grading guide</a> for more detail.
            </p>
          `
        },
  
        {
          q: "Why do refurbished devices have different grades?",
  
          a: `
            <p>
              Refurbished devices come from different previous-use environments, so the level of cosmetic wear and overall condition can naturally vary.
            </p>
            <p>
              Grading helps you compare options more clearly, especially when choosing between appearance, value, and budget.
            </p>
          `
        },
  
        {
          q: "How does the grading system help me choose the right product?",
  
          a: `
            <p>
              The grading system helps you choose based on your budget, cosmetic expectations, professional use, everyday use, or value preference.
            </p>
            <p>
              If appearance matters most, a higher grade may suit you better. If savings matter more, a lower grade may still give you a functional device at a better price.
            </p>
          `
        },
  
        {
          q: "Where can I see the grade of a product before purchasing?",
  
          a: `
            <p>
              You can find the grade on the product page, condition label, specifications table, product description, and product variants where applicable.
            </p>
            <p>
              Always treat the product listing as the source of truth for the exact grade, condition, specs, accessories, and images.
            </p>
          `
        },
  
        {
          q: "Do all devices go through the same grading process?",
  
          a: `
            <p>
              Yes, all device types follow the same general grading and checking process, with minor differences depending on the product type.
            </p>
            <p>
              For example, a laptop, monitor, desktop, tablet, or phone may have different components checked, but the goal is always to assess condition clearly before listing.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Grade Definitions",
  
      questions: [
  
        {
          q: "What does Grade A (Excellent) mean?",
  
          a: `
            <p>
              Grade A means excellent refurbished condition.
            </p>
            <p>
              The device is in as-new cosmetic condition with minimal to no visible signs of use, although very light, barely noticeable marks may be present.
            </p>
            <p>
              It is fully tested and in perfect working order, with all features and components operating as expected.
            </p>
          `
        },
  
        {
          q: "What does Grade B (Good) mean?",
  
          a: `
            <p>
              Grade B means great refurbished condition.
            </p>
            <p>
              The device may show light signs of use, such as minor surface scratches or small scuffs, but it remains clean and well-presented overall.
            </p>
            <p>
              It is fully tested and in excellent working condition, with no impact on performance or usability.
            </p>
          `
        },
  
        {
          q: "What does Grade C (Fair) mean?",
  
          a: `
            <p>
              Grade C means fair refurbished condition with heavier visible signs of use.
            </p>
            <p>
              You may notice more visible scratches, dents, or surface wear. The device is still fully tested and functional, but it may show signs of extended use.
            </p>
            <p>
              Grade C can suit you if you want a lower price and are comfortable with more noticeable cosmetic wear.
            </p>
          `
        },
  
        {
          q: "What does Grade D (Poor / Clearance) mean?",
  
          a: `
            <p>
              Grade D means poor cosmetic condition, with significant signs of use such as heavy scratches, dents, cosmetic damage, or long-term wear.
            </p>
            <p>
              The device is still tested and functional, but it is best suited to value-focused buyers who care more about basic use and lower price than appearance.
            </p>
            <p>
              Grade D is different from Value Grade Tech, which is a separate range with its own listing-specific terms and no standard warranty coverage.
            </p>
          `
        },
  
        {
          q: "How is “Excellent” different from “Like-New”?",
  
          a: `
            <p>
              “Excellent” is used to describe a high refurbished grade with very minimal cosmetic wear.
            </p>
            <p>
              “Like-new” is a cosmetic description only. It does not mean the device is brand new unless the product is specifically listed as brand new.
            </p>
          `
        },
  
        {
          q: "Can two devices with the same grade look different?",
  
          a: `
            <p>
              Yes. A grade is a condition band, not an identical appearance guarantee.
            </p>
            <p>
              Two devices in the same grade may have slightly different marks, wear patterns, or cosmetic details while still fitting the same condition standard.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Cosmetic Condition",
  
      questions: [
  
        {
          q: "What kind of cosmetic wear is acceptable for each grade?",
  
          a: `
            <p>
              Cosmetic wear depends on the grade of the device.
            </p>
            <p>
              <span
                class="info-popup"
                data-info='
                  <h3>Grade Comparison Guide</h3>
                  <div style="overflow-x:auto;">
                    <table style="width:100%; border-collapse:collapse; min-width:680px;">
                      <thead>
                        <tr>
                          <th style="text-align:left; padding:10px; border:1px solid #E5E5E5;">Grade</th>
                          <th style="text-align:left; padding:10px; border:1px solid #E5E5E5;">Cosmetic expectation</th>
                          <th style="text-align:left; padding:10px; border:1px solid #E5E5E5;">Best suited for</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style="padding:10px; border:1px solid #E5E5E5;"><strong>Grade A</strong></td>
                          <td style="padding:10px; border:1px solid #E5E5E5;">As-new condition with minimal to no visible signs of use. May have very light marks.</td>
                          <td style="padding:10px; border:1px solid #E5E5E5;">Cleanest appearance and professional presentation.</td>
                        </tr>
                        <tr>
                          <td style="padding:10px; border:1px solid #E5E5E5;"><strong>Grade B</strong></td>
                          <td style="padding:10px; border:1px solid #E5E5E5;">Light signs of use, minor surface scratches, or small scuffs.</td>
                          <td style="padding:10px; border:1px solid #E5E5E5;">A strong balance of appearance and value.</td>
                        </tr>
                        <tr>
                          <td style="padding:10px; border:1px solid #E5E5E5;"><strong>Grade B-</strong></td>
                          <td style="padding:10px; border:1px solid #E5E5E5;">Moderate signs of use, light scratches, or surface wear that is more noticeable.</td>
                          <td style="padding:10px; border:1px solid #E5E5E5;">Everyday use with good value.</td>
                        </tr>
                        <tr>
                          <td style="padding:10px; border:1px solid #E5E5E5;"><strong>Grade C+</strong></td>
                          <td style="padding:10px; border:1px solid #E5E5E5;">Noticeable scratches, scuffs, or light dents while still presentable.</td>
                          <td style="padding:10px; border:1px solid #E5E5E5;">Budget-conscious buyers who accept visible wear.</td>
                        </tr>
                        <tr>
                          <td style="padding:10px; border:1px solid #E5E5E5;"><strong>Grade C</strong></td>
                          <td style="padding:10px; border:1px solid #E5E5E5;">Heavier visible scratches, dents, or surface wear.</td>
                          <td style="padding:10px; border:1px solid #E5E5E5;">Lower-cost everyday use where appearance is less important.</td>
                        </tr>
                        <tr>
                          <td style="padding:10px; border:1px solid #E5E5E5;"><strong>Grade D</strong></td>
                          <td style="padding:10px; border:1px solid #E5E5E5;">Significant wear, heavy scratches, dents, or cosmetic damage.</td>
                          <td style="padding:10px; border:1px solid #E5E5E5;">Basic use and value-focused buying.</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                '
              >
                View grade comparison
              </span>
            </p>
          `
        },
  
        {
          q: "Are there examples of what each grade looks like?",
  
          a: `
            <p>
              Yes, you can view examples and more detailed condition guidance in our <a href="https://itfactoryaustralia.com.au/pages/product-grades">grading guide</a>.
            </p>
            <p>
              Product photos, condition labels, descriptions, and specifications should also be checked before purchasing.
            </p>
          `
        },
  
        {
          q: "Do some grades include devices with scratches or dents?",
  
          a: `
            <p>
              Yes, some grades can include scratches, scuffs, dents, or visible wear.
            </p>
            <p>
              Grade A has the least visible wear, Grade B and B- may show light to moderate wear, Grade C+ and C show more noticeable wear, and Grade D may show significant cosmetic wear or damage.
            </p>
          `
        },
  
        {
          q: "Will a Grade A device look “brand new”?",
  
          a: `
            <p>
              Grade A is excellent refurbished condition and may look close to like-new, but it is not guaranteed to be brand new.
            </p>
            <p>
              A device is only brand new if it is specifically listed as brand new on the product page.
            </p>
          `
        },
  
        {
          q: "How noticeable are imperfections in Grade B or Grade C devices?",
  
          a: `
            <p>
              Grade B devices usually have light signs of use, such as small scuffs or minor surface scratches.
            </p>
            <p>
              Grade B- may show more noticeable surface wear, while Grade C+ and Grade C can show more visible scratches, dents, or general wear.
            </p>
            <p>
              These devices are still selected for buyers who want functional refurbished tech at better value.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Functionality & Testing",
  
      questions: [
  
        {
          q: "Do all grades have the same functional testing standards?",
  
          a: `
            <p>
              Yes, all standard refurbished grades pass the same general functional testing standards.
            </p>
            <p>
              The grade helps describe condition and expected wear, but standard refurbished products are still tested before listing.
            </p>
          `
        },
  
        {
          q: "Are devices with performance issues ever sold?",
  
          a: `
            <p>
              Standard refurbished devices are tested before listing and are expected to operate as described.
            </p>
            <p>
              Any known performance issue, quirk, or fault should only appear in Value Grade Tech listings, where the exact condition is explained in the individual product description and photos.
            </p>
          `
        },
  
        {
          q: "How do you ensure a device is fully functional before listing?",
  
          a: `
            <p>
              Devices go through functional checks before listing.
            </p>
            <p>
              <span
                class="info-popup"
                data-info='
                  <h3>Testing and Quality Checks</h3>
                  <p>Checks may vary slightly by product type, but can include:</p>
                  <ul>
                    <li>Power and startup checks</li>
                    <li>Screen and display checks</li>
                    <li>Keyboard, trackpad, buttons, and controls</li>
                    <li>Ports and charging</li>
                    <li>Wi-Fi and Bluetooth</li>
                    <li>Speakers, webcam, and microphone where applicable</li>
                    <li>Storage, RAM, and operating system checks</li>
                    <li>Battery and charging checks where applicable</li>
                    <li>Final quality check before listing or dispatch</li>
                  </ul>
                '
              >
                View testing and quality checks
              </span>
            </p>
          `
        },
  
        {
          q: "Are batteries tested as part of the grading process?",
  
          a: `
            <p>
              Yes, batteries are checked as part of the testing process where the device includes a battery.
            </p>
            <p>
              Battery life can still vary by model, age, usage, settings, and battery type.
            </p>
          `
        },
  
        {
          q: "Can a Grade C device have reduced battery life compared to Grade A?",
  
          a: `
            <p>
              Lower grades can usually show more wear overall, and battery performance may vary between individual devices.
            </p>
            <p>
              Battery condition is assessed during testing, but it is not the main grading factor. Battery life still depends on the model, age, usage, and device settings.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Battery & Wear Parts",
  
      questions: [
  
        {
          q: "How is battery health considered in grading?",
  
          a: `
            <p>
              Battery health is assessed during testing, but it is not the main factor used to determine the cosmetic grade.
            </p>
            <p>
              The grade mainly helps describe overall condition and wear, while battery performance can still vary by device, model, age, and usage.
            </p>
          `
        },
  
        {
          q: "Does a Grade A device come with a reliable battery capacity?",
  
          a: `
            <p>
              A Grade A device has been tested and is expected to operate properly, but battery life can still vary by model, age, settings, and how you use it.
            </p>
            <p>
              Grade A describes excellent refurbished condition, not a brand-new battery guarantee.
            </p>
          `
        },
  
        {
          q: "Are wear parts like keyboards or hinges tested and graded?",
  
          a: `
            <p>
              Yes, wear parts are checked where applicable.
            </p>
            <p>
              This may include keyboards, hinges, trackpads, ports, buttons, fans, screens, chargers, and other key components depending on the device type.
            </p>
          `
        },
  
        {
          q: "Can batteries be replaced before sale?",
  
          a: `
            <p>
              Yes, batteries can be replaced before sale where needed and where replacement is suitable for the device.
            </p>
            <p>
              This is handled case-by-case depending on the model, battery condition, parts availability, and overall device assessment.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Choosing the Right Grade",
  
      questions: [
  
        {
          q: "Which grade should I choose for everyday use?",
  
          a: `
            <p>
              For everyday use, Grade B, Grade B-, Grade C+, and Grade C can all be suitable depending on your budget and cosmetic expectations.
            </p>
            <p>
              If you want a cleaner-looking device, choose a higher grade. If you are comfortable with visible wear, a lower grade can offer better value.
            </p>
          `
        },
  
        {
          q: "Which grade is best for business or professional use?",
  
          a: `
            <p>
              For business or professional use, Grade A, Grade B, or Grade B- is usually the better choice.
            </p>
            <p>
              These grades are better suited when presentation, client-facing use, or a cleaner appearance matters.
            </p>
          `
        },
  
        {
          q: "Is Grade A worth the extra cost compared to Grade B?",
  
          a: `
            <p>
              Grade A may be worth the extra cost if you want the cleanest cosmetic condition and a device that looks closer to like-new.
            </p>
            <p>
              Grade B may be better value if you are happy to accept minor cosmetic wear while still getting a fully tested device.
            </p>
          `
        },
  
        {
          q: "Are clearance or Grade D devices suitable for parts or repairs?",
  
          a: `
            <p>
              Grade D devices are best for value-focused buyers who accept significant cosmetic wear but still want a functional device for basic use.
            </p>
            <p>
              Value Grade Tech is a separate range of individually listed products that may have significant cosmetic wear, faults, degradation, reduced battery condition, impaired functionality or other clearly disclosed limitations.
            </p>
            <p>
              Value Grade Tech products are not eligible for our voluntary 30-day change-of-mind return policy and do not include our voluntary 6-month IT Factory hardware warranty.
            </p>
            <p>
              The known condition, faults and limitations are disclosed on the individual listing before purchase.
            </p>
            <p>
              You should review the full product description and photos carefully before buying any Value Grade Tech item.
            </p>
          `
        },
  
        {
          q: "How do I decide between cosmetic condition and price?",
  
          a: `
            <p>
              Choose a higher grade if appearance, presentation, or professional use matters to you.
            </p>
            <p>
              Choose a lower grade if you want stronger savings and are comfortable with cosmetic wear.
            </p>
            <p>
              The best grade is the one that matches how much wear you are happy to accept for the price you want to pay.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Comparisons & Clarifications",
  
      questions: [
  
        {
          q: "How are IT Factory Australia grades different from other refurbished grading systems?",
  
          a: `
            <p>
              Refurbished grading systems can vary between sellers, so it is best to check IT Factory Australia’s own grade definitions before comparing products.
            </p>
            <p>
              Always review the product grade, condition label, description, specifications, photos, and included accessories before purchasing.
            </p>
          `
        },
  
        {
          q: "Does a higher grade affect warranty coverage?",
  
          a: `
            <p>
              No. Standard eligible refurbished grades receive the same voluntary IT Factory hardware warranty coverage regardless of cosmetic grade.
            </p>
            <p>
              Value Grade Tech is the exception. It is a separate range and does not include our voluntary 6-month hardware warranty.
            </p>
            <p>
              You can review full details in our <a href="https://itfactoryaustralia.com.au/policies/refund-policy">returns and warranty policy</a>.
            </p>
          `
        },
  
        {
          q: "Are accessories included regardless of grade?",
  
          a: `
            <p>
              Accessories are based on the product listing, not just the grade.
            </p>
            <p>
              Please check the <strong>What’s Included</strong> section on the product page to confirm exactly what comes with the device.
            </p>
          `
        },
  
        {
          q: "Can colour or model variations affect how grades are applied?",
  
          a: `
            <p>
              Grading is based on each device’s condition, but some colours, materials, or finishes may show wear more visibly than others.
            </p>
            <p>
              This means two devices with the same grade may not look identical, even if they meet the same grading standard.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Photos & Representation",
  
      questions: [
  
        {
          q: "Why can’t I get individual photos of the exact device before purchasing?",
  
          a: `
            <p>
              Exact individual photos may not always be available for every standard refurbished product.
            </p>
            <p>
              You can contact us to request additional photos or information before buying, and we will help where possible.
            </p>
            <p>
              Value Grade Tech listings include exact unit photos because the condition is specific to each individual item.
            </p>
          `
        },
  
        {
          q: "How accurate are the product images for each grade?",
  
          a: `
            <p>
              Product images may be exact unit photos, representative images, manufacturer-style images, or a mix depending on the product.
            </p>
            <p>
              For Value Grade Tech products, exact unit photos are provided because the condition is listing-specific.
            </p>
          `
        },
  
        {
          q: "What should I expect if a product photo doesn’t match exactly?",
  
          a: `
            <p>
              Product photos are a guide, but the grade, condition label, specifications, accessories, and product description should be treated as the source of truth.
            </p>
            <p>
              If you are unsure before buying, contact us and we can provide more information where possible.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Quality Assurance",
  
      questions: [
  
        {
          q: "Do devices that don’t meet your grading standards get recycled or reused?",
  
          a: `
            <p>
              Devices that do not meet grading standards may be kept for parts, have reusable parts recovered where possible, responsibly recycled, sent to recycling partners, or safely disposed of.
            </p>
            <p>
              The best pathway depends on the device, condition, components, and what can be reused responsibly.
            </p>
          `
        },
  
        {
          q: "Are all devices data-wiped before grading and sale?",
  
          a: `
            <p>
              Yes, devices are data-wiped where applicable before grading and sale.
            </p>
            <p>
              IT Factory Australia is partnered with Blancco, and data wiping forms part of our refurbishment and quality assurance process.
            </p>
          `
        },
  
        {
          q: "Do you guarantee cosmetic descriptions match the listed grade?",
  
          a: `
            <p>
              We grade devices carefully and aim for the listed grade and condition description to match the device accurately.
            </p>
            <p>
              Minor variation can still occur within each grade because grading is a condition band, not an identical appearance guarantee.
            </p>
          `
        },
  
        {
          q: "What happens if a device arrives with wear worse than advertised grade?",
  
          a: `
            <p>
              If you believe your device has arrived with wear worse than the advertised grade, contact IT Factory Australia support as soon as possible.
            </p>
            <p>
              Please include your order number and clear photos of the device so we can review the issue and advise the next steps.
            </p>
            <p>
              Email <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a>.
            </p>
          `
        }
  
      ]
    }
  
  ],
  
  "Quick FAQs": [
  
    {
      sub: "Contact & Support",
  
      questions: [
  
        {
          q: "How do I contact IT Factory Australia for general enquiries?",
  
          a: `
            <p>
              You can contact IT Factory Australia by email, phone, or through our contact page.
            </p>
            <p>
              Email <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a>, call <a href="tel:1300589579">1300 589 579</a> and select option 1, or use our <a href="https://itfactoryaustralia.com.au/pages/contact">contact page</a>.
            </p>
          `
        },
  
        {
          q: "What is your phone number and email for support?",
  
          a: `
            <p>
              You can email us at <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a>.
            </p>
            <p>
              You can also call <a href="tel:1300589579">1300 589 579</a> and select option 1.
            </p>
          `
        },
  
        {
          q: "Can I visit your physical store without an appointment?",
  
          a: `
            <p>
              No, visits, pickups, and support visits are appointment-only.
            </p>
            <p>
              Please contact us first and wait for confirmation before visiting.
            </p>
          `
        },
  
        {
          q: "How do I schedule an in-store appointment?",
  
          a: `
            <p>
              You can schedule an appointment by emailing us, calling us, or using our contact page.
            </p>
            <p>
              Please wait for confirmation of the day and time before visiting.
            </p>
            <p>
              Email <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a>, call <a href="tel:1300589579">1300 589 579</a> and select option 1, or use our <a href="https://itfactoryaustralia.com.au/pages/contact">contact page</a>.
            </p>
          `
        },
  
        {
          q: "What are your business hours for phone and in-store support?",
  
          a: `
            <p>
              Phone and appointment-based support is available Monday to Friday, 8:30am to 4:00pm Sydney time.
            </p>
            <p>
              If you contact us outside these hours, we will respond as soon as possible during business hours.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Business & Bulk Orders",
  
      questions: [
  
        {
          q: "Do you offer discounts for bulk or corporate orders?",
  
          a: `
            <p>
              Bulk and corporate pricing may be available case-by-case.
            </p>
            <p>
              Please contact us with your order requirements so we can review product availability, quantity, pricing, and timing.
            </p>
          `
        },
  
        {
          q: "How can businesses set up an account for bulk purchases?",
  
          a: `
            <p>
              You can contact us to discuss a business account or bulk purchase request.
            </p>
            <p>
              Please include your business name, ABN if available, contact person, products needed, quantity, budget, and timeframe.
            </p>
            <p>
              Email <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a> or use our <a href="https://itfactoryaustralia.com.au/pages/contact">contact page</a>.
            </p>
          `
        },
  
        {
          q: "Are there special terms for business or educational orders?",
  
          a: `
            <p>
              Special terms may be available case-by-case for business, corporate, school, TAFE, university, or institutional orders.
            </p>
            <p>
              Please contact us before ordering so we can review your needs and confirm what options may be available.
            </p>
          `
        },
  
        {
          q: "Can businesses request custom configurations for refurbished devices?",
  
          a: `
            <p>
              Yes, custom configurations may be available case-by-case.
            </p>
            <p>
              Availability depends on stock, model, compatibility, parts, approval, and the requirements of your order.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Website & Technical Issues",
  
      questions: [
  
        {
          q: "Why isn’t the website loading properly on my browser?",
  
          a: `
            <p>
              Try refreshing the page, clearing your browser cache, updating your browser, opening a private window, disabling extensions, trying another device, or checking your internet connection.
            </p>
            <p>
              If the issue continues, contact us and include the page you were trying to access and the device or browser you were using.
            </p>
          `
        },
  
        {
          q: "What should I do if I can’t complete my purchase online?",
  
          a: `
            <p>
              First, check your cart, shipping details, payment details, browser, and any discount code you are trying to use.
            </p>
            <p>
              You can also try another payment method or another browser.
            </p>
            <p>
              If you still cannot complete checkout, email <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a> and we can help review the issue.
            </p>
          `
        },
  
        {
          q: "How do I report a bug or technical issue on the website?",
  
          a: `
            <p>
              You can report a website issue by contacting support with the page URL, device, browser, screenshot, issue description, and the time and date it happened.
            </p>
            <p>
              Email the details to <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a>.
            </p>
          `
        },
  
        {
          q: "Can I save items in my cart and complete the purchase later?",
  
          a: `
            <p>
              Items may remain in your cart so you can return later, depending on your browser and session.
            </p>
            <p>
              Stock is not reserved until checkout is completed, so an item may sell out before you return.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Product Availability & Requests",
  
      questions: [
  
        {
          q: "What should I do if a device I want is out of stock?",
  
          a: `
            <p>
              If a device is out of stock, you can sign up for back-in-stock notifications where available on the product page.
            </p>
            <p>
              You can also contact support for alternative recommendations or check similar products on the website.
            </p>
          `
        },
  
        {
          q: "Can I request a specific model or configuration?",
  
          a: `
            <p>
              Yes, you can request a specific model or configuration.
            </p>
            <p>
              Please email us with the brand, model, specifications, budget, and timeframe you are looking for.
            </p>
            <p>
              Availability is not guaranteed, but we can review your request and let you know what may be possible.
            </p>
          `
        },
  
        {
          q: "How often do you restock popular devices?",
  
          a: `
            <p>
              Restocks are supply-dependent and can vary because refurbished stock depends on what becomes available.
            </p>
            <p>
              Popular models may return at different times, but exact restock dates are not always guaranteed.
            </p>
          `
        },
  
        {
          q: "Do you offer notifications when a product becomes available?",
  
          a: `
            <p>
              Yes, unavailable products may have a notification option on the product page.
            </p>
            <p>
              If available, you can sign up to be notified when that item comes back in stock.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Customer Feedback & Reviews",
  
      questions: [
  
        {
          q: "How can I leave feedback or a review for a product?",
  
          a: `
            <p>
              You may be able to leave a review from the product page, order page, post-purchase email, or through Google Reviews.
            </p>
            <p>
              We appreciate feedback because it helps other buyers feel more confident when choosing refurbished tech.
            </p>
          `
        },
  
        {
          q: "Can I report an issue with a review I submitted?",
  
          a: `
            <p>
              Yes, you can contact support if there is an issue with a review you submitted.
            </p>
            <p>
              Please include your name, email address, review details, and what you would like us to check.
            </p>
          `
        },
  
        {
          q: "Are reviews moderated before being displayed on the website?",
  
          a: `
            <p>
              Yes, reviews may be moderated before being displayed.
            </p>
            <p>
              Moderation may be used for spam, offensive content, fake reviews, irrelevant content, or inappropriate language.
            </p>
          `
        },
  
        {
          q: "How do I submit a testimonial for IT Factory Australia?",
  
          a: `
            <p>
              You can submit a testimonial by leaving a Google review or using the review form provided in a post-purchase email.
            </p>
            <p>
              If you are unsure where to submit feedback, you can contact support and we can point you in the right direction.
            </p>
          `
        }
  
      ]
    },
  
    {
      sub: "Miscellaneous",
  
      questions: [
  
        {
          q: "Are refurbished devices eligible for software updates?",
  
          a: `
            <p>
              Refurbished devices may be eligible for software updates, depending on the model, age, manufacturer support, operating system, and compatibility.
            </p>
            <p>
              Where possible, devices are prepared with the latest compatible operating system unless stated otherwise in the product description.
            </p>
          `
        },
  
        {
          q: "Can I request additional photos or information about a device?",
  
          a: `
            <p>
              Yes, you can request additional photos or information before purchasing.
            </p>
            <p>
              We can sometimes provide extra details for requested products, depending on the item and availability.
            </p>
            <p>
              Email <a href="mailto:sales@itfactory.com.au">sales@itfactory.com.au</a> with the product you are interested in.
            </p>
          `
        },
  
        {
          q: "How do I trade in my old device for a refurbished one?",
  
          a: `
            <p>
              Trade-ins are not currently available as a standard program at IT Factory Australia.
            </p>
            <p>
              If you have a device you would like to discuss, you can contact support and we can let you know whether any option may be available.
            </p>
          `
        },
  
        {
          q: "Are there any FAQs specific to certain device types (phones, tablets, laptops)?",
  
          a: `
            <p>
              Device-specific guides may be added later through our articles and help resources.
            </p>
            <p>
              In the meantime, you can check the product listing carefully or contact support if you need help choosing a laptop, desktop, phone, tablet, monitor, or accessory.
            </p>
            <p>
              You can also visit our <a href="https://itfactoryaustralia.com.au/blogs/buying-guides">articles</a> when device-specific guides become available.
            </p>
          `
        },
  
        {
          q: "How do I stay updated on news, promotions, or sustainability initiatives?",
  
          a: `
            <p>
              You can subscribe to our emails and become an ITF Insider for exclusive deals, updates, and promotions.
            </p>
            <p>
              You can also follow us on <a href="https://www.facebook.com/itfactoryaustralia/" target="_blank" rel="noopener">Facebook</a> and <a href="https://www.instagram.com/itfactoryaustralia/" target="_blank" rel="noopener">Instagram</a>.
            </p>
            <p>
              For sustainability updates, you can visit our <a href="https://itfactoryaustralia.com.au/pages/our-sustainability-commitment">sustainability page</a>.
            </p>
          `
        }
  
      ]
    }
  
  ]
  
      };
  
      /* CREATE NAVIGATION */
  
      Object.keys(faqData).forEach((category, index) => {
  
        const btn = document.createElement('button');
  
        btn.textContent = category;
  
        if(index === 0){
          btn.classList.add('active');
        }
  
        btn.addEventListener('click', () => {
          selectCategory(category, btn);
        });
  
        navContainer.appendChild(btn);
  
      });
  
      /* CATEGORY RENDER */
  
      function selectCategory(category, button){
  
        navContainer.querySelectorAll('button').forEach(btn => {
          btn.classList.remove('active');
        });
  
        button.classList.add('active');
  
        contentContainer.innerHTML = `<h2>${category}</h2>`;
  
        faqData[category].forEach(group => {
  
          const subHeader = document.createElement('div');
  
          subHeader.classList.add('faq-subcategory');
  
          subHeader.textContent = group.sub;
  
          const questionsGroup = document.createElement('div');
  
          questionsGroup.classList.add('faq-questions-group');
  
          group.questions.forEach(faq => {
  
            const item = document.createElement('div');
  
            item.classList.add('faq-item');
  
            const question = document.createElement('div');
  
            question.classList.add('faq-question');
  
            question.textContent = faq.q;
  
            const answer = document.createElement('div');
  
            answer.classList.add('faq-answer');
  
            answer.innerHTML = faq.a;
  
            question.addEventListener('click', () => {
  
    const isOpen = question.classList.contains('active');
  
    // Close ALL other questions in this subcategory
    questionsGroup.querySelectorAll('.faq-question').forEach(q => {
      q.classList.remove('active');
    });
  
    questionsGroup.querySelectorAll('.faq-answer').forEach(a => {
      a.classList.remove('open');
    });
  
    // Re-open clicked question if it was previously closed
    if (!isOpen) {
      question.classList.add('active');
      answer.classList.add('open');
    }
  
  });
  
            item.appendChild(question);
  
            item.appendChild(answer);
  
            questionsGroup.appendChild(item);
  
          });
  
          subHeader.addEventListener('click', () => {
  
    const isOpen = subHeader.classList.contains('active');
  
    // Close ALL subcategories
    contentContainer.querySelectorAll('.faq-subcategory').forEach(sub => {
      sub.classList.remove('active');
    });
  
    contentContainer.querySelectorAll('.faq-questions-group').forEach(group => {
      group.classList.remove('open');
    });
  
    // Close ALL questions
    contentContainer.querySelectorAll('.faq-question').forEach(q => {
      q.classList.remove('active');
    });
  
    contentContainer.querySelectorAll('.faq-answer').forEach(a => {
      a.classList.remove('open');
    });
  
    // Re-open clicked subcategory if it was previously closed
    if (!isOpen) {
      subHeader.classList.add('active');
      questionsGroup.classList.add('open');
    }
  
  });
  
          contentContainer.appendChild(subHeader);
  
          contentContainer.appendChild(questionsGroup);
  
        });
  
      }
  
      /* LOAD DEFAULT CATEGORY */
  
      selectCategory(
        Object.keys(faqData)[0],
        navContainer.querySelector('button.active')
      );
  
      /* MODAL */
  
      function openModal(contentHTML){
  
        modalContent.innerHTML = contentHTML;
  
        modal.style.display = 'flex';
  
        document.body.style.overflow = 'hidden';
  
      }
  
      function closeModal(){
  
        modal.style.display = 'none';
  
        document.body.style.overflow = '';
  
      }
  
      modalClose.addEventListener('click', closeModal);
  
      modal.addEventListener('click', (e) => {
  
        if(e.target === modal){
          closeModal();
        }
  
      });
  
      root.addEventListener('click', function(e){
  
        if(e.target.classList.contains('info-popup')){
  
          const contentHTML = e.target.getAttribute('data-info');
  
          openModal(contentHTML);
  
        }
  
      });
  
    }
  
    function initAllITFFAQs(){
  
      document.querySelectorAll('.itf-faq-app').forEach(root => {
        initITFFAQ(root);
      });
  
    }
  
    // Initial page load
    if(document.readyState === 'loading'){
  
      document.addEventListener('DOMContentLoaded', initAllITFFAQs);
  
    } else {
  
      initAllITFFAQs();
  
    }
  
    // Shopify Theme Editor section reload support
    document.addEventListener('shopify:section:load', initAllITFFAQs);
  
  })();